/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-07-02 11:17:11
 * @LastEditors: 侯鹏许
 * @LastEditTime: 2021-07-14 17:45:34
 * @Description: file content
 */
/**
 * Created by pengxu on 2017/6/23.
 * 180814二次授权
 */

/**
 * config
 */

window.cfg = {
  isLoc: location.href.indexOf("localhost") > -1 ? true : false,
  isDev: location.href.indexOf("devAndTest") > -1 ? true : false,
  isTest: (location.host.indexOf("qmyx.") > -1 || location.host.indexOf("sjzstest.") > -1 || location.host.indexOf("rstest.") > -1 || location.host.indexOf("cartest.") > -1) ? true : false,
  helpShowWx: 0,
  apihost: /\.(com|net|org|cn)$/i.test(location.hostname)
    ? (location.hostname.substring(0, location.hostname.indexOf(".")) + ".ttrushi.com") : 'qmyx.ttrushi.com',
  subdomian: ''
}
function localOpenid() {
  if (cfg.isLoc) {
    let url = location.href;
    let tmpObj = {};
    let tmpArr = url.split("?");
    if (tmpArr.length == 2) {
      let urlParam = tmpArr[1];
      let tmpArr1 = urlParam.split('&');
      tmpArr1 = tmpArr1.map(function (e) {
        tmpObj[e.split('=')[0]] = e.split('=')[1];
      })
    }
    if (tmpObj.fake) {
      cfg.apihost = tmpObj.fake.split("_")[0] + ".ttrushi.com";
    } else {
      alert("没有fake参数")
    }
  }
}
localOpenid();

if (cfg.isTest) {
  yqAnalytics.init({
    env: "test",
    appId: "b7b0f945a5fd4ab197eb77f4743c09aa",
  });
} else {
  yqAnalytics.init({
    appId: "82d2ff334d404f6c914b4fe8e68f4008",
  });
}

window.initWXJSSDK = function (plugFun) {
  if (!myTemp.openid) {
    return;
  }
  var shareLink = `${location.protocol}//${location.host}/h5/t2.html?id=${myPageData.PageId}`;
  var shareTitle = myPageData.WxShare && (myPageData.WxShare.Title || myPageData.BrowserTabTitle);
  var shareDesc = myPageData.WxShare && (myPageData.WxShare.Description || myPageData.BrowserTabTitle);

  var shareImg = myPageData.WxShare && (myPageData.WxShare.FilePath);
  var usercard2_masteropenid = wj.cookie.get("usercard2_masteropenid");
  if (usercard2_masteropenid && false) {
    $.ajax({
      type: "GET",
      url: api.wx,
      async: false,
      data: {
        j: JSON.stringify({
          "action": "/hb/HbUserAction/fansInfo",
          "requestParam": {
            obj: {
              openid: usercard2_masteropenid
            }
          },
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "url": location.href
        })
      },
      success: function (data) {
        var cardinfo = data.obj;
        var myhost = location.host.indexOf("localhost") > -1 ? "qmyx.rushinews.com" : location.host;
        shareLink = `http://${myhost}/h5/usercard2.html?openid=${cardinfo.openid}&refereeopenid=${myTemp.openid}`;

        shareTitle = `我是${cardinfo.gappname || cardinfo.projectname}的${cardinfo.ui_name || cardinfo.name || cardinfo.nickname}，欢迎您随时联系`;
        shareDesc = `手机号：${cardinfo.ui_mobile || cardinfo.mobile}${cardinfo.ui_weixin ? "微信号：" + cardinfo.ui_weixin : ""}`;
        shareImg = cardinfo.headimgurl;
      }
    });
  }
  if (myTemp.psn) {
    shareLink += "&psn=" + myTemp.psn;
  }
  shareLink += "&refereeopenid=" + myTemp.openid;
  if (myTemp.rscuid) {
    shareLink += "&rscuid=" + myTemp.rscuid;
  }
  shareLink = wj.addUrlParamFromObj(shareLink, {
    tt: new Date().getTime()
  })
  if (myTemp.share_api) {
    shareLink = myTemp.share_api.replace("{desturl}", encodeURIComponent(shareLink));
  }
  if (plugFun) {
    shareLink = plugFun();
  }
  var tmpUrl2047 = api.wx;
  if (location.host.indexOf("fqjzw.") > -1 || location.host.indexOf("qdpdats.") > -1 || location.host.indexOf("yqjisu.") > -1 || location.host.indexOf("zyljxyf.") > -1
    || location.host.indexOf("jsby.") > -1
    || location.host.indexOf("xzsklf.") > -1) {
    tmpUrl2047 = location.protocol + "//shjinbao.ttrushi.com/qc-webapp/wxapi.do";
  } else if (location.host.indexOf("jxwk.") > -1 || location.host.indexOf("zhzy.") > -1 || location.host.indexOf("zagbgn.") > -1) {
    tmpUrl2047 = location.protocol + "//yunmeiha.ttrushi.com/qc-webapp/wxapi.do";
  } else if (location.host.indexOf("rdjt.") > -1 || location.host.indexOf("shhxbst.") > -1) {
    tmpUrl2047 = location.protocol + "//lsdyb.ttrushi.com/qc-webapp/wxapi.do";
  } else if (location.host.indexOf("wlcbinh.") > -1 || location.host.indexOf("hllsq.") > -1 || location.host.indexOf("qcbdt.") > -1) {
    tmpUrl2047 = location.protocol + "//haopanyu.ttrushi.com/qc-webapp/wxapi.do";
  } else if (location.host.indexOf("hdlyzsx.") > -1 || location.host.indexOf("lxfdcwxq.") > -1) {
    tmpUrl2047 = location.protocol + "//yuanquan.ttrushi.com/qc-webapp/wxapi.do";
  } else if (location.host.indexOf("baolong.") > -1 || location.host.indexOf("hyhtd.") > -1) {
    tmpUrl2047 = location.protocol + "//loupany.ttrushi.com/qc-webapp/wxapi.do";
  } else if (location.host.indexOf("hxdcj.") > -1) {
    tmpUrl2047 = location.protocol + "//yqkjw.ttrushi.com/qc-webapp/wxapi.do";
  }

  $.ajax({
    type: "GET",
    url: tmpUrl2047,
    data: {
      j: JSON.stringify({
        openid: location.host.indexOf("fqjzw.") > -1 ? 'oPg9r1Smqfm7L0xRQg31bv3QEurM' : myTemp.openid,
        passport: location.host.indexOf("fqjzw.") > -1 ? 'b6ea31a39077f68fb85ba41109f51b40' : myTemp.passport,
        "vericode": "",
        "url": location.href,
        "action": "getAppid",
        "requestParam": {}
      }),
      t: 6
    },
    success: function (data) {
      if (data.code < 0) {
        return;
      }
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.obj, // 必填，公众号的唯一标识
        timestamp: data.jsParams.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.jsParams.noncestr, // 必填，生成签名的随机串
        signature: data.jsParams.signature, // 必填，签名，见附录1
        jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'onMenuShareQZone',
          'getLocation',
          'openLocation'
        ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        openTagList: [
          'wx-open-launch-weapp',
          'wx-open-launch-app'
        ]
      });
      if (!myPageData.WxShare) {
        return;
      }

      wx.ready(function () {
        window.ContentSelfAudio = new Audio();
        window.ContentSelfAudio.src =
          "https://assets.rurushishi.com/sharelib/iPhone.mp3";
        wx.onMenuShareTimeline({
          title: shareTitle,
          link: shareLink,
          imgUrl: shareImg,
          success: function () {
            setTimeout(function () {
              wxShare();
            }, 500);
          },
          cancel: function () {

          }
        });

        wx.onMenuShareAppMessage({
          title: shareTitle,
          desc: shareDesc,
          link: shareLink,
          imgUrl: shareImg,
          type: '',
          dataUrl: '',
          success: function () {

            wxShare();
          },
          cancel: function () {

          }
        });


        wx.onMenuShareQQ({
          title: shareTitle,
          desc: shareDesc,
          link: shareLink,
          imgUrl: shareImg,
          success: function () {

            wxShare();
          },
          cancel: function () {

          }
        });

        wx.onMenuShareWeibo({
          title: shareTitle,
          desc: shareDesc,
          link: shareLink,
          imgUrl: shareImg,
          success: function () {

            wxShare();
          },
          cancel: function () {

          }
        });

        wx.onMenuShareQZone({
          title: shareTitle,
          desc: shareDesc,
          link: shareLink,
          imgUrl: shareImg,
          success: function () {

            wxShare();
          },
          cancel: function () {

          }
        });

        if (myPageData.Opengps) {
          wx.getLocation({
            type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function (res) {
              myTemp.gcj02 = res;
              var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
              var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
              var speed = res.speed; // 速度，以米/每秒计
              var accuracy = res.accuracy; // 位置精度
              // alert(`维度${latitude} 经度${longitude} 速度${speed} 精度${accuracy}`)
              uploadLocation(latitude, longitude, speed, accuracy);
              biz.handlerYqAnalyticsEvent('authLocation')
            }
          });
        }

      });
    }
  });
}

cfg.subdomian = cfg.apihost.substring(0, cfg.apihost.indexOf("."));
if (cfg.isLoc) {
  var contentType = 2;
  if (contentType == 1) {
    //多图形式
  } else if (contentType == 2) {
    //图文形式
  } else if (contentType == 3) {
    //视频形式
  }
}
window.api = {
  h5: location.protocol + "//" + cfg.apihost + "/qc-webapp/h5count.do?",
  wx: location.protocol + "//" + cfg.apihost + "/qc-webapp/wxapi.do"
}
/**
 * defined function
 */

window.wj = {
  clientW: document.documentElement.clientWidth,
  clientH: document.documentElement.clientHeight,
  qs: function (name, isDecodeURI) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
      if (isDecodeURI)
        return decodeURI(r[2]);
      return r[2];
    }
    return null;
  },
  browser: {
    info: navigator.appVersion,
    versions: function () {
      var u = navigator.userAgent, app = navigator.appVersion;
      return {
        trident: u.indexOf('Trident') > -1,
        presto: u.indexOf('Presto') > -1,
        webKit: u.indexOf('AppleWebKit') > -1,
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,
        mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/),
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
        iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1,
        iPad: u.indexOf('iPad') > -1,
        webApp: u.indexOf('Safari') == -1,
        wxGroup: u.toLowerCase().match(/MicroMessenger/i) == 'micromessenger',
        wx: u.toLowerCase().match(/MicroMessenger/i) == 'micromessenger' && u.match(/wxwork/i) != 'wxwork',
        dy: u.toLowerCase().match(/toutiaomicroapp/i) == 'toutiaomicroapp',
        wxwork: u.match(/wxwork/i) == 'wxwork'
      };
    }()
  },
  isMobileNumber: function (mobile) {
    var b1 = /^1[3-9]\d{9}$/.test(String(mobile).replace(/^0+/g, ''));
    var b2 = /^0\d{2,3}-?\d{7,8}$/.test(mobile);
    var b3 = false;
    if (returnCitySN && returnCitySN.cname) {
      if (!/[\u4e00-\u9fa5]+/.test(returnCitySN.cname)) {
        b3 = /^[' '|+|-|a|\d]{5,20}$/.test(mobile);
      }
    }
    return b1 || b2 || b3;
  },
  isNumber: function (str) {
    return /^[1-9]+[0-9]*]*$/.test(str);
  },
  loadImgs: function (urls, progressCallback, completeCallback) {
    var myInterVal = null;
    var imgs = [], index = 0, _load = function _load() {
      var img = new Image;
      img.src = urls[index], img.onload = function () {
        imgs.push(img);
        if (progressCallback) {
          progressCallback();
        }
        index++;
        if (index / urls.length == 1) {
          completeCallback();
        } else {
          _load();
        }
      }
    };
    _load();
  },
  loadAudio: function (src, callback) {
    var audio = new Audio(src);
    audio.onloadedmetadata = callback;
    audio.src = src;
  },
  cookie: {
    set: function (key, val, second, domain) {//设置cookie方法，秒过期
      var date = new Date(); //获取当前时间
      date.setTime(date.getTime() + second * 1000); //格式化为cookie识别的时间
      var cookieVal = key + "=" + val + ";path=/;expires=" + date.toGMTString() + (domain ? (";domain=" + domain) : "");  //设置cookie
      document.cookie = cookieVal;
    },
    get: function (key) {//获取cookie方法
      /*获取cookie参数*/
      var getCookie = document.cookie.replace(/[ ]/g, "");  //获取cookie，并且将获得的cookie格式化，去掉空格字符
      var arrCookie = getCookie.split(";")  //将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
      var tips = "";  //声明变量tips
      for (var i = 0; i < arrCookie.length; i++) {   //使用for循环查找cookie中的tips变量
        var arr = arrCookie[i].split("=");   //将单条cookie用"等号"为标识，将单条cookie保存为arr数组
        if (key == arr[0]) {  //匹配变量名称，其中arr[0]是指的cookie名称，如果该条变量为tips则执行判断语句中的赋值操作
          tips = arr[1];   //将cookie的值赋给变量tips
          break;   //终止for循环遍历
        }
      }
      return tips;
    },
    delete: function (key) { //删除cookie方法
      var date = new Date(); //获取当前时间
      date.setTime(date.getTime() - 10000); //将date设置为过去的时间
      document.cookie = key + "=v; expires =" + date.toGMTString();//设置cookie
    }
  },
  clientInfo: (function () {
    var attrs = [
      "appCodeName"
      , "appName"
      , "appVersion"
      , "cookieEnabled"
      , "language"
      , "platform"
      , "product"
      , "vendor"
    ];
    var str = "";
    attrs.forEach(function (e, i) {
      str += e + ":" + navigator[e] + ";";
    })
    return str;
  })(),
  changeTitle: function (title) {
    if (wj.browser.versions.wx && wj.browser.versions.ios) {
      var $body = $('body');
      document.title = title;
      // hack在微信等webview中无法修改document.title的情况
      var $iframe = $('<iframe style="display:none;opacity: 0;" src=""></iframe>');
      $iframe.on('load', function () {
        setTimeout(function () {
          $iframe.off('load').remove();
        }, 0);
      }).appendTo($body);
    } else {
      document.title = title;
    }
  },
  getismp: function (fun) {
    if (location.host.indexOf("localhost") > -1 && location.href.indexOf("ismp=1") > -1) {
      fun(true);
    } else {
      if (!wx.miniProgram) return;
      wx.miniProgram.getEnv(function (res) {
        fun(res.miniprogram);
      });
    }
  },
  //内嵌在小程序中的跳转，需要在页面引入wxjssdk1.32+
  mp: {
    nav: function (url) {
      if (!wx.miniProgram) return;
      wx.miniProgram.navigateTo({ url: url });
    },
    navBack: function (url) {
      if (!wx.miniProgram) return;
      wx.miniProgram.navigateBack({ url: url });
    },
    switch: function (url) {
      if (!wx.miniProgram) return;
      wx.miniProgram.switchTab({ url: url });
    },
    rel: function (url) {
      if (!wx.miniProgram) return;
      wx.miniProgram.reLaunch({ url: url });
    },
    red: function (url) {
      if (!wx.miniProgram) return;
      wx.miniProgram.redirectTo({ url: url });
    }
  },
  /**
 * 从url上获取参数
 */
  getParamFromUrl(url) {
    if (url.indexOf("#wechat_redirect") > -1) {
      url = url.replace("#wechat_redirect", "");
    }
    let tmpObj = {};
    let tmpArr = url.split("?");
    if (tmpArr.length == 2) {
      let urlParam = tmpArr[1];
      let tmpArr1 = urlParam.split('&');
      tmpArr1 = tmpArr1.map(function (e) {
        tmpObj[e.split('=')[0]] = e.split('=')[1];
      })
    }
    return tmpObj;
  },
  getUrlRemoveParams(url) {
    url = url || location.href;
    if (url.indexOf("?") != -1) {
      url = url.split("?")[0];
      return url;
    }
    return url;
  },
  objToUrlParam(obj) {
    let urlParam = '';
    Object.keys(obj).forEach(function (e) {
      if (obj[e]) {
        urlParam += `${e}=${obj[e]}&`
      }
    })
    if (urlParam.length > 0) {
      urlParam = urlParam.substring(0, urlParam.length - 1);
    }
    return urlParam;
  },
  addUrlParamFromObj(url, obj) {
    let newUrl = this.getUrlRemoveParams(url);
    let newUrlParam = this.getParamFromUrl(url);
    newUrlParam = {
      ...newUrlParam,
      ...obj
    };
    let newUrlParamStr = this.objToUrlParam(newUrlParam);
    if (newUrlParamStr) {
      return newUrl + '?' + newUrlParamStr;
    }
    return newUrl;
  },
  isObject: function (p) {
    return Object.prototype.toString.call(p) === "[object Object]"
  },
  getGuid: function () {
    let guid = "";
    for (var i = 1; i <= 32; i++) {
      var n = Math.floor(Math.random() * 16.0).toString(16);
      guid += n;
      if ((i == 8) || (i == 12) || (i == 16) || (i == 20))
        guid += "";
    }
    return guid;
  },
  clientLog: {
    info() {
      this.clientLogFun(1, arguments)
    },
    warn() {
      this.clientLogFun(2, arguments)
    },
    error() {
      this.clientLogFun(3, arguments)
    },
    clientLogFun() {
      if (cfg.subdomian != 'qmyx') {
        return;
      }
      let filterMsg = '';
      let content = '';
      if (arguments[1].length == 0) {

      } else if (arguments[1].length == 1) {
        if (Object.prototype.toString.call(arguments[1][0]) === "[object String]") {
          filterMsg = arguments[1][0];
        }
      } else if (arguments[1].length == 2) {
        if (Object.prototype.toString.call(arguments[1][0]) === "[object String]") {
          filterMsg = arguments[1][0];
        }
        content = arguments[1][1];
        if (Object.prototype.toString.call(content) === "[object Object]" || Object.prototype.toString.call(content) === "[object Array]") {
          content = JSON.stringify(content);
        } else if (Object.prototype.toString.call(content) === "[object Null]") {
          content = 'Null';
        } else if (Object.prototype.toString.call(content) === "[object Undefined]") {
          content = 'Undefined';
        } else if (Object.prototype.toString.call(content) === "[object String]" || Object.prototype.toString.call(content) === "[object Number]") {

        } else {
          content = '';
        }
      } else if (arguments[1].length > 2) {

        if (Object.prototype.toString.call(arguments[1][0]) === "[object String]") {
          filterMsg = arguments[1][0];
        }
        content = []
        for (let index = 1; index < arguments[1].length; index++) {
          let element = arguments[1][index];
          if (Object.prototype.toString.call(element) === "[object Object]" || Object.prototype.toString.call(element) === "[object Array]") {
            element = JSON.stringify(element);
          } else if (Object.prototype.toString.call(element) === "[object Null]") {
            element = 'Null';
          } else if (Object.prototype.toString.call(element) === "[object Undefined]") {
            element = 'Undefined';
          } else if (Object.prototype.toString.call(element) === "[object String]" || Object.prototype.toString.call(element) === "[object Number]") {

          } else {
            element = '';
          }
          content.push(element);
        }
        content = JSON.stringify(content);
      }

      $.ajax({
        type: "POST",
        url: "https://log.yqyuntech.com/clientLog",
        async: false,
        data: {
          "repositoryId": 4,
          "levelId": arguments[0],
          "showId": window.myTemp.guid || '',
          "userId": window.myTemp.openid || '',
          "filterMsg": filterMsg,
          "content": content,
          "clientTime": new Date().getTime()
        },
        success: function (data) {
        }
      });
    }
  }
};
/**
 * loading
 */
window.myTemp = {
  audio: null,//音乐对象
  arrSrc: [],//图片列表
  arrSrcMyServer: [],//本地WebServer上的图片进行预加载
  guid: wj.getGuid(),
  openid: "",
  appid: "",
  refereeopenid: "",
  bottomBtnCount: 0,
  isRecordIng: 0,
  img_text: {
    audioList: []
  },
  receiveMsgOpenId: "",//接收消息人openid
  sendImgBaseData: "",
  imgFaceCut: null,
  consultingLink: "",//咨询链接
  isAlreadyAfterActIpGetConsultingLink: false,//是否在act=ip之后请求了获取聊天对象
  isGetUpUserMobile: false,//是否请求获取过了上级手机号
  upUserMobile: "",//上级手机号
  share_api: "",
  windowWidth: '',
  windowHeight: '',
  cookieKeys: {
    beforeAuthUrl: 'beforeAuthUrl_t2'
  },
  saleCardUser: {
    openid: '',
    info: {}
  },
  appMark: "crm",
  photoRewardConfig: {},//晒照配置
  gcj02: null
};

var tmpImgTimeImgId = 0;//当前图片id
var tmpImgTimeObj = {};
window.myPageData = {};
myPageData.PageId = wj.qs("id");
// if (wj.qs("refereeopenid")) {
//   wj.cookie.set("refereeopenid", wj.qs("refereeopenid"), 60 * 10);
// } else {
//   if (location.href.indexOf("passport") > -1 && wj.qs("openid") > -1 && wj.qs("signature") > -1) {

//   } else {
//     wj.cookie.delete("refereeopenid");
//   }
// }
// if (wj.cookie.get("refereeopenid")) {
//   myTemp.refereeopenid = wj.cookie.get("refereeopenid");
// }
// if (wj.qs("rscuid")) {
//   wj.cookie.set("rscuid", wj.qs("rscuid"), 60 * 10);
// } else {
//   if (location.href.indexOf("passport") > -1 && wj.qs("openid") > -1 && wj.qs("signature") > -1) {

//   } else {
//     wj.cookie.delete("rscuid");
//   }
// }
// if (wj.cookie.get("rscuid")) {
//   myTemp.rscuid = wj.cookie.get("rscuid");
// }
// if (wj.qs("psn")) {
//   wj.cookie.set("psn" + myPageData.PageId, wj.qs("psn"), 60 * 10);
// }
// if (wj.cookie.get("psn" + myPageData.PageId)) {
//   myTemp.psn = wj.cookie.get("psn" + myPageData.PageId);
// }
// if (wj.qs("processinstanceid")) {
//   wj.cookie.set("processinstanceid" + myPageData.PageId, wj.qs("processinstanceid"), 60 * 10);
// }
// if (wj.cookie.get("processinstanceid" + myPageData.PageId)) {
//   myTemp.processinstanceid = wj.cookie.get("processinstanceid" + myPageData.PageId);
// }
// var xcxuid = wj.qs("xcxuid"), xcxappid = wj.qs("xcxappid"), xcxprojectid = wj.qs("xcxprojectid"), xcxgzhappid = wj.qs("xcxgzhappid");
// if (xcxuid && xcxappid && xcxprojectid && xcxgzhappid) {
//   wj.cookie.set("xcxuid", xcxuid, 60 * 5);
//   wj.cookie.set("xcxappid", xcxappid, 60 * 5);
//   wj.cookie.set("xcxprojectid", xcxprojectid, 60 * 5);
//   wj.cookie.set("xcxgzhappid", xcxgzhappid, 60 * 5);
// } else {
//   xcxuid = wj.cookie.get("xcxuid"), xcxappid = wj.cookie.get("xcxappid"), xcxprojectid = wj.cookie.get("xcxprojectid"), xcxgzhappid = wj.cookie.get("xcxgzhappid");
// }
// var purephonenumber = wj.qs("purephonenumber");
// if (purephonenumber) {
//   wj.cookie.set("purephonenumber", purephonenumber, 60 * 5);
// } else {
//   purephonenumber = wj.cookie.get("purephonenumber");
// }
// var qsEntry = wj.qs("entry");
// if (qsEntry) {
//   wj.cookie.set("entry" + myPageData.PageId, qsEntry, 60 * 10);
// } else {
//   qsEntry = wj.cookie.get("entry" + myPageData.PageId);
// }
// var qsT9id = wj.qs("t9id");
// if (qsT9id) {
//   wj.cookie.set("t9id" + myPageData.PageId, qsT9id, 60 * 10);
// } else {
//   qsT9id = wj.cookie.get("t9id" + myPageData.PageId);
// }
// var qsT9psn = wj.qs("t9psn");
// if (qsT9psn) {
//   wj.cookie.set("t9psn" + myPageData.PageId, qsT9psn, 60 * 10);
// } else {
//   qsT9psn = wj.cookie.get("t9psn" + myPageData.PageId);
// }

// var qsHomeUrl = wj.qs("homeurl");
// if (qsHomeUrl) {
//   wj.cookie.set("homeurl" + myPageData.PageId, qsHomeUrl, 60 * 10);
// } else {
//   qsHomeUrl = wj.cookie.get("homeurl" + myPageData.PageId);
// }
(function () {
  let urlParam = wj.getParamFromUrl(location.href);
  myTemp.refereeopenid = urlParam.refereeopenid;
  myTemp.rscuid = urlParam.rscuid;
  myTemp.psn = urlParam.psn;
  myTemp.processinstanceid = urlParam.processinstanceid;
  myTemp.fopenid = urlParam.fopenid;
  myTemp.xcxuid = urlParam.xcxuid;
  myTemp.xcxappid = urlParam.xcxappid;
  myTemp.xcxprojectid = urlParam.xcxprojectid;
  myTemp.xcxgzhappid = urlParam.xcxgzhappid;
  myTemp.purephonenumber = urlParam.purephonenumber;
  myTemp.entry = urlParam.entry;
  myTemp.t9id = urlParam.t9id;
  myTemp.t9psn = urlParam.t9psn;
  myTemp.homeurl = urlParam.homeurl;
})();
function firstAuth() {
  if (location.href.indexOf("passport") > -1 && location.href.indexOf("openid") > -1) {
    var j = wj.qs("j");
    var data = decodeURIComponent(j);
    data = JSON.parse(data);
    myTemp.appid = data.appid;
    myTemp.openid = data.openid;
    myTemp.passport = data.passport;
    var authObj = {
      appid: data.appid,
      openid: data.openid,
      passport: data.passport
    }
    // wj.cookie.set("openid", authObj.openid, 1 * 60 * 60 * 24, location.host);
    // wj.cookie.set("passport", authObj.passport, 1 * 60 * 60 * 24, location.host);
    wj.cookie.set("pack1_20171129", JSON.stringify(authObj), 1 * 60 * 60 * 24);
    if (authObj && authObj.openid) {
      wj.cookie.set("openid", authObj.openid, 1 * 60 * 60 * 24 * 365);
    }
    if (authObj && authObj.passport) {
      wj.cookie.set("passport", authObj.passport, 1 * 60 * 60 * 24 * 365);
    }
    wj.cookie.set("pack1_20171129_first", JSON.stringify(authObj), 1 * 60 * 60 * 24);
    secondAuthGetUrl();
  } else {
    //静默授权
    $.ajax({
      type: "GET",
      url: api.wx,
      async: false,
      data: {
        j: JSON.stringify({
          "url": location.href,
          "action": "getConfig",
          "requestParam": {}
        }),
        t: 6
      },
      success: function (data) {
        if (data && data.obj) {
          if (data.obj.share_api) {
            wj.cookie.set("share_api", data.obj.share_api, 60 * 10);
          }
          let authCallBackUrl = location.href.replace("#wechat_redirect", "");
          let urlParam = wj.getParamFromUrl(authCallBackUrl);
          delete urlParam.xcxcountry;
          delete urlParam.xcxprovince;
          delete urlParam.xcxcity;
          authCallBackUrl = wj.addUrlParamFromObj(wj.getUrlRemoveParams(authCallBackUrl), urlParam);
          let authUrl = `${location.protocol}//${location.host}/qc-webapp/wxapi.do?appid=${data.obj.appid}&scope=snsapi_base&wxauthcburl=${encodeURIComponent(authCallBackUrl)}`;
          location.href = authUrl;
          return false;
        }

      }
    });
  }

}

function secondAuthGetUrl() {
  var dataObj = {
    "id": myPageData.PageId
  }
  if (myTemp.psn) {
    dataObj.psn = myTemp.psn;
  }
  if (myTemp.rscuid) {
    dataObj.rscuid = myTemp.rscuid;
  } else {
    dataObj.rscuid = myTemp.openid;
  }
  var haveuserinfo = 0;
  $.ajax({
    type: "GET",
    async: false,
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/hb/HbH5Action/getPageInfo",
        "requestParam": {
          obj: dataObj
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {
      if (data) {
        haveuserinfo = data.haveuserinfo;
      }
      if (data && data.obj && data.obj.PageData) {
        myPageData = JSON.parse(decodeURIComponent(data.obj.PageData.replace(/[+]/g, "%20")));
        wj.changeTitle(myPageData.BrowserTabTitle);
        if (data.obj.gzh_qrcode) {
          myPageData.gzh_qrcode = data.obj.gzh_qrcode;
        }
        if (data.obj.gzh_headimg) {
          myPageData.gzh_headimg = data.obj.gzh_headimg;
        }
        myPageData.Other = {};
        Object.keys(data.obj).forEach(function (e) {
          if (e != "PageData") {
            myPageData.Other[e] = data.obj[e];
          }
        })
        myTemp.appid = myPageData.Other.gzh_appid;
        if (wj.browser.versions.wx) {
          initWXJSSDK();
        }
      } else {
        // alert("H5内容获取失败！")
      }
    }
  });
  if (haveuserinfo) {
    var authObj = JSON.parse(wj.cookie.get("pack1_20171129_first"));
    wj.cookie.set("pack1_20171129_second", JSON.stringify(authObj), 1 * 60 * 60 * 24);
    let beforeAuthUrl = wj.cookie.get(myTemp.cookieKeys.beforeAuthUrl)
    if (beforeAuthUrl) {
      wj.cookie.delete(myTemp.cookieKeys.beforeAuthUrl);
      location.href = decodeURIComponent(beforeAuthUrl);
    }
  } else {
    //有二次授权的话进行二次授权
    if (myPageData.Isrushiauth && myPageData.Isrushiauth == 1) {
      //如是授权
      var appid = "wxf1efeb9b9d6f6f06";
      var host = "rushi.rushinews.com";
      var scope = "snsapi_userinfo";
      var arrUrl = location.href.split("/");
      var strPage = arrUrl[arrUrl.length - 1];
      var authUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=http://" + host + "/qc-webapp/oauthcallback.do&response_type=code&scope=" + scope + "&state=http://" + location.host + "/h5/" + strPage + "#wechat_redirect";
      location.href = authUrl;
    }
    else if (myPageData.Isrushiauth && myPageData.Isrushiauth == 2) {
      //本公众号网页授权
      $.ajax({
        type: "GET",
        url: api.wx,
        async: false,
        data: {
          j: JSON.stringify({
            "url": location.href,
            "action": "getConfig",
            "requestParam": {}
          }),
          t: 6
        },
        success: function (data) {
          if (data && data.obj) {
            if (data.obj.share_api) {
              wj.cookie.set("share_api", data.obj.share_api, 60 * 10);
            }
            let authCallBackUrl = location.href.replace("#wechat_redirect", "");
            let urlParam = wj.getParamFromUrl(authCallBackUrl);
            delete urlParam.xcxcountry;
            delete urlParam.xcxprovince;
            delete urlParam.xcxcity;
            authCallBackUrl = wj.addUrlParamFromObj(wj.getUrlRemoveParams(authCallBackUrl), urlParam);
            let authUrl = `${location.protocol}//${location.host}/qc-webapp/wxapi.do?appid=${data.obj.appid}&scope=snsapi_userinfo&wxauthcburl=${encodeURIComponent(authCallBackUrl)}`;
            location.href = authUrl;
            return false;
          }
        }
      });
    }
  }
}

function secondAuth() {

  if (location.href.indexOf("passport") > -1 && location.href.indexOf("openid") > -1) {
    //回调
    var j = wj.qs("j");
    var data = decodeURIComponent(j);
    data = JSON.parse(data);
    myTemp.appid = data.appid;
    myTemp.openid = data.openid;
    myTemp.passport = data.passport;
    var authObj = {
      appid: data.appid,
      openid: data.openid,
      passport: data.passport
    }
    wj.cookie.set("pack1_20171129", JSON.stringify(authObj), 1 * 60 * 60 * 24);
    wj.cookie.set("pack1_20171129_second", JSON.stringify(authObj), 1 * 60 * 60 * 24);
    let beforeAuthUrl = wj.cookie.get(myTemp.cookieKeys.beforeAuthUrl)
    if (beforeAuthUrl) {
      wj.cookie.delete(myTemp.cookieKeys.beforeAuthUrl);
      location.href = decodeURIComponent(beforeAuthUrl);
    }
  }
}

// 如果是在企微打开就替换成企微的路径
if (wj.browser.versions.wxwork && !cfg.isLoc) {
  location.replace(location.href.replace("/h5/", "/qwh5/"));
} else {
  if (wj.browser.versions.wxGroup) {
    let urlParams = wj.getParamFromUrl(location.href);
    // 兼容企微转发的链接调整api路径
    if (wj.browser.versions.wx && urlParams.gzhSubDomain) {
      window.cfg.apihost = `${urlParams.gzhSubDomain}.ttrushi.com`;
      window.api = {
        h5: location.protocol + "//" + cfg.apihost + "/qc-webapp/h5count.do?",
        wx: location.protocol + "//" + cfg.apihost + "/qc-webapp/wxapi.do",
        wxQcwebapp: location.protocol + "//" + cfg.apihost + "/qc-webapp"
      }
    }
    // 如果是企微域名的链接，且在微信环境下
    if (wj.browser.versions.wx && urlParams.gzhDomain && (location.host == 'qywx.ruthus.com' || location.host == 'qyweb.gbtse.com')) {
      if (urlParams.openid) {
        delete urlParams.openid;
      }
      if (urlParams.passport) {
        delete urlParams.passport;
      }
      location.href = wj.addUrlParamFromObj(wj.getUrlRemoveParams(location.href).replace(location.host, urlParams.gzhDomain), urlParams);
    } else {
      if (urlParams.openid && urlParams.passport) {
        myTemp.openid = urlParams.openid;
        myTemp.passport = urlParams.passport;
      } else {
        var isFirstAuth = wj.cookie.get("pack1_20171129_first");
        var isSecondAuth = wj.cookie.get("pack1_20171129_second");
        if (isFirstAuth) {
          var authObj = JSON.parse(wj.cookie.get("pack1_20171129_first"));
          myTemp.appid = authObj.appid;
          myTemp.openid = authObj.openid;
          myTemp.passport = authObj.passport;
          if (!isSecondAuth) {
            secondAuth();
            // 两步授权取消第二步授权，下次继续授权。
            isSecondAuth = wj.cookie.get("pack1_20171129_second");
            if (!isSecondAuth) {
              secondAuthGetUrl();
            }
          }
        } else {
          // 存授权之前的链接
          let urlParam = wj.getParamFromUrl(location.href);
          if (!urlParam.j) {
            wj.cookie.set(myTemp.cookieKeys.beforeAuthUrl, encodeURIComponent(location.href));
          }
          firstAuth();
        }
      }
    }
  } else {
    if (cfg.isLoc) {
      var fake = wj.qs("fake")
      switch (fake) {
        case "qmyx_hope":
          myTemp.openid = "oj3y9wGThdLqhn0bZWOj7DeO2Tww";
          myTemp.passport = "b4de197ab7b03e9d014116821e90d54f";
          break;
        case "qmyx_may":
          myTemp.openid = "oj3y9wLPfkK5dkr9rK9i3GyGIXwE";
          myTemp.passport = "b212d1bb3eb7e5ab971f0a8dcb327829";
          break;
        default:
          myTemp.openid = "oj3y9wGThdLqhn0bZWOj7DeO2Tww";
          myTemp.passport = "b4de197ab7b03e9d014116821e90d54f";
          break;
      }
    }
  }
}
(function () {
  if (wj.browser.versions.wx) {
    // 授权一致性校验
    var isFirstAuth = wj.cookie.get("pack1_20171129_first");
    var isSecondAuth = wj.cookie.get("pack1_20171129_second");
    var authObj = wj.cookie.get("pack1_20171129");
    if ((isFirstAuth && isSecondAuth && authObj) || (isFirstAuth && authObj)) {
      isFirstAuth = JSON.parse(isFirstAuth);
      authObj = JSON.parse(authObj);
      if (isSecondAuth) {
        isSecondAuth = JSON.parse(isSecondAuth);
      } else {
        isSecondAuth = { openid: "" }
      }

      if ((isFirstAuth.openid == isSecondAuth.openid && isFirstAuth.openid == authObj.openid) || isFirstAuth.openid == authObj.openid) {

      } else {
        wj.cookie.delete("pack1_20171129_first");
        wj.cookie.delete("pack1_20171129_second");
        wj.cookie.delete("pack1_20171129");
        // var strUrl = location.href.split('?')[0];
        // strUrl += "?id=" + myPageData.PageId;
        // strUrl += "&psn=" + myTemp.psn;
        // if (wj.cookie.get("refereeopenid")) {
        //   myTemp.refereeopenid = wj.cookie.get("refereeopenid");
        //   strUrl += "&refereeopenid=" + myTemp.refereeopenid;
        // }
        // location.href = strUrl;
        location.reload();
      }
    }
  }
})();

(function () {
  var dataObj = {
    "id": myPageData.PageId
  }
  if (myTemp.psn) {
    dataObj.psn = myTemp.psn;
  }
  if (myTemp.rscuid) {
    dataObj.rscuid = myTemp.rscuid;
  } else {
    dataObj.rscuid = myTemp.openid;
  }
  $.ajax({
    type: "GET",
    async: false,
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/hb/HbH5Action/getPageInfo",
        "requestParam": {
          obj: dataObj
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {
      if (data && data.obj && data.obj.PageData) {
        myPageData = JSON.parse(decodeURIComponent(data.obj.PageData.replace(/[+]/g, "%20")));
        myPageData.Other = {};
        Object.keys(data.obj).forEach(function (e) {
          if (e != "PageData") {
            myPageData.Other[e] = data.obj[e];
          }
        })
        myTemp.appid = myPageData.Other.gzh_appid;
        wj.changeTitle(myPageData.BrowserTabTitle);
      } else {
        // alert("H5内容获取失败！")
      }
    }
  });
})();

if (wj.cookie.get("share_api")) {
  myTemp.share_api = wj.cookie.get("share_api");
}
if (wj.cookie.get("refereeopenid")) {
  myTemp.refereeopenid = wj.cookie.get("refereeopenid");
}
if (wj.cookie.get("rscuid")) {
  myTemp.rscuid = wj.cookie.get("rscuid");
}
if (wj.browser.versions.wx) {
  initWXJSSDK();
}
if (myPageData.Imgs && myPageData.Imgs.length == 1) {
  $(".arrow").addClass("hide");
}
if (myPageData.Imgs) {
  myPageData.Imgs.forEach(function (e, i) {
    myTemp.arrSrc.push(e.filepath);
  })
}
if (myPageData.CsPic)
  myTemp.arrSrc.push(myPageData.CsPic);
if (myPageData.WxQrcode)
  myTemp.arrSrc.push(myPageData.WxQrcode);
myTemp.arrSrc.forEach(function (e, i) {
  if (e.indexOf("rs.static.rushinews.com") > -1 || e.indexOf(location.host) > -1 || e.indexOf("../") > -1) {
    myTemp.arrSrcMyServer.push(e);
  }
})
if (myPageData.Redirectto == 1) {
  // 问卷还让页面停留在loading
} else {
  if (myTemp.arrSrcMyServer.length > 0) {
    wj.loadImgs(myTemp.arrSrcMyServer, function () {
      console.count("加载图片");
    }, function () {
      $(".index_scrim").css("display", "none");
      bindMusic();
    })
  } else if (myPageData.Imagetext && myPageData.Imagetext != "") {
    //图文类型
    $(".index_scrim").css("display", "none");
    bindMusic();
  } else {
    $(".index_scrim").css("display", "none");
    bindMusic();
  }
}

function bindMusic() {
  //绑定音乐
  if (myPageData.Music) {
    if (myPageData.Music.indexOf(".mp3") > -1 || myPageData.Music.indexOf(".MP3") > -1) {
      myTemp.audio = document.getElementById("music_audio");
      if (wj.browser.versions.ios) {
        myTemp.audio.src = myPageData.Music;
        setTimeout(function () {
          myTemp.audio.play();
        }, 150)
        document.addEventListener("WeixinJSBridgeReady", function () {
          myTemp.audio.play();
        }, false);
        $(".music_img").addClass("music_img_play");
      } else {
        // wj.loadAudio(myPageData.Music, function () {
        //     myTemp.audio.src = myPageData.Music;
        //     myTemp.audio.play();
        //     $(".music_img").addClass("music_img_play");
        // });
        // myTemp.audio.src = myPageData.Music;

        myTemp.audio.src = myPageData.Music;
        var isPlaying = myTemp.audio.currentTime > 0 && !myTemp.audio.paused && !myTemp.audio.ended && myTemp.audio.readyState > 2;
        if (!isPlaying) {
          setTimeout(function () {
            myTemp.audio.play().catch(function (e) {
              console.log("", e.message);
              console.log("", e.description);
            });
            $(".music_img").addClass("music_img_play");
          }, 150);
        } else {

        }
      }
      //点击音乐图标
      $(".music").on("click", function () {
        if (myTemp.audio.paused) {
          myTemp.audio.play();
          $(".music_img").addClass("music_img_play");
        } else {
          myTemp.audio.pause();
          $(".music_img").removeClass("music_img_play");
        }
      });
    } else {
      alert("仅支持mp3格式音乐！")
    }
  }
}

/**
 * layout
 */

function fixPagesHeight() {
  var windowHeight = $(window).innerHeight();
  myTemp.windowHeight = windowHeight;
  myTemp.windowWidth = $(window).innerWidth();
  if ((myPageData.Showpv && myPageData.Showpv == 1) || (myPageData.Showshares && myPageData.Showshares == 1) || (myPageData.Showsubcribepage && myPageData.Showsubcribepage == 1 && myPageData.Subcribepageurl)) {
    $(".page .music").css({
      top: "3.5rem"
    })
    var tmpHeight = windowHeight - $(".count").height();
    $('.swiper-slide,.swiper-container').css({
      height: tmpHeight
    });
    $('.swiper-slide img').css({
      height: tmpHeight
    });
    $('.xn-wrapper').css({
      top: "50px"
    })

    if ((myPageData.Showpv && myPageData.Showpv == 1 || myPageData.Showshares && myPageData.Showshares == 1)) {
      getCount();
    }
    if (myPageData.Showsubcribepage && myPageData.Showsubcribepage == 1 && myPageData.Subcribepageurl != "") {
      $(".count_subcribe").removeClass("hide")
      $(".count_subcribe").on("click", function () {
        AddCount(14);
        location.href = myPageData.Subcribepageurl;
      })
    }
    //请求接口获取数量
    $(".count").removeClass("hide");
  } else {
    $('.swiper-slide,.swiper-container').css({
      height: windowHeight
    });
    $('.swiper-slide img').css({
      height: windowHeight
    });
  }

  // $(".page").css({
  //     height: windowHeight
  // });
}

fixPagesHeight();
window.onresize = function () {
  fixPagesHeight();
}

//根据配置显示按钮
if (myTemp.appid == "wx3d1ccb01e00a82b9") {
  $(".btn_dy_a .txt").html("报名");
}
if (myPageData.PageId == 3123 || myPageData.PageId == 3663) {
  $(".btn_dy_a .txt").html("报名");
}
if (myPageData.PageId == 4618) {
  $(".btn_form").css({
    "marginTop": "-5rem"
  })
}

if (myPageData.PageId == 7199) {
  $(".btn_zd").css({
    "top": "26rem"
  })
  $(".btn_dh").css({
    "top": "32rem"
  })
}

if (myPageData.PageId == 7200) {
  $(".btn_zd").css({
    "top": "26rem"
  })
  $(".btn_dh").css({
    "top": "32rem"
  })
}


if (!myPageData.Music) {
  $(".music").css({ "display": "none" });
}
// 显示致电
if (myPageData.Tel || myPageData.Propcall) {
  $(".btn_zd").addClass("menu_show");
  myTemp.bottomBtnCount++;
}
if (myPageData.Chat) {
  if (wj.browser.versions.wx) {
    $(".btn_zx").addClass("menu_show");
    myTemp.bottomBtnCount++;
  }
}
if (myPageData.IsPhone) {
  $(".btn_th").addClass("menu_show");
  myTemp.bottomBtnCount++;
}
if (myPageData.NavUrl) {
  $(".btn_dh").addClass("menu_show");
  myTemp.bottomBtnCount++;
}
if (myPageData.WxCode && myPageData.WxQrcode) {
  $(".btn_gw").addClass("menu_show");
  myTemp.bottomBtnCount++;
}
if ((myPageData.Survey || myPageData.Surveyext) && myTemp.bottomBtnCount < 6) {
  $(".btn_dy").addClass("menu_show");
  myTemp.bottomBtnCount++;
  new Promise(function (resolve, reject) {
    // getuserinfo
    $.ajax({
      type: "GET",
      async: true,
      url: api.wx,
      data: {
        j: JSON.stringify({
          "action": "/persid/PresidentAction/selectHbextend",
          "requestParam": {
            openid: myTemp.openid
          },
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "url": location.href
        })
      },
      success: function (data) {
        if (data && data.obj && data.obj.length > 0) {
          resolve(data.obj[0]);
        } else {
          resolve(false);
        }
      }
    });
  }).then(function (myUserInfo) {
    if (myPageData.Surveyext) {
      myPageData.Survey = myPageData.Surveyext;
    }
    myPageData.Survey = myPageData.Survey.replace("ddipctest", "wjpro");
    if (myPageData.Survey.indexOf(".html?") > -1) {
      myPageData.Survey = myPageData.Survey + "&";
    } else {
      myPageData.Survey = myPageData.Survey + "?";
    }
    myPageData.Survey += "appid=" + myTemp.appid + "&openid=" + myTemp.openid + "&pageid=" + myPageData.PageId + "&host=" + location.host + "&refereeopenid=" + myTemp.refereeopenid;
    if (myUserInfo) {
      if (myUserInfo.name) {
        myPageData.Survey += "&nickname=" + encodeURIComponent(myUserInfo.name);
      }
      if (myUserInfo.headimgurl) {
        myPageData.Survey += "&headimage=" + encodeURIComponent(myUserInfo.headimgurl);
      }
    }
    if (myPageData.Surveyhideid && myPageData.Surveyhideanswer) {
      myPageData.Survey += "&Surveyhideid=" + myPageData.Surveyhideid + "&Surveyhideanswer=" + encodeURIComponent(myPageData.Surveyhideanswer);
    }
    var tmp781 = "";
    if (location.href.indexOf("&j=") > -1) {
      tmp781 = location.href.split("&j=")[0] + (myTemp.openid ? "&refereeopenid=" + myTemp.openid : "");
    } else {
      tmp781 = location.href + (myTemp.openid ? "&refereeopenid=" + myTemp.openid : "");
    }
    if (myTemp.psn) {
      tmp781 += "&psn=" + myTemp.psn;
    }
    myPageData.Survey += "&share_link=" + encodeURIComponent(tmp781);
    // 直达
    if (myPageData.Redirectto == 1 && myTemp.openid) {
      SendTime(function () {
        location.href = myPageData.Survey;
      })
    }
  });

}
if (myPageData.Mall && myTemp.bottomBtnCount < 6) {
  $(".btn_sc").addClass("menu_show");
  myTemp.bottomBtnCount++;
}
if (myPageData.LiveUrl && myTemp.bottomBtnCount < 6) {
  $(".btn_live").addClass("menu_show");
  myTemp.bottomBtnCount++;
}
if (myPageData.Record && myTemp.bottomBtnCount < 6) {
  $(".btn_record").addClass("menu_show");
  myTemp.bottomBtnCount++;
}
if (myPageData.Photo && parseInt(myPageData.Photo) == 1 && myTemp.bottomBtnCount < 6) {
  $(".btn_photo").addClass("menu_show");
  myTemp.bottomBtnCount++;
  comreq.getPhotoRewardConfig(myPageData.PageId).then((res) => {
    if (res.obj) {
      myTemp.photoRewardConfig = res.obj;
      console.log("myTemp.photoRewardConfig", myTemp.photoRewardConfig);
    }
  })
}

//街景
if (myPageData.Streeturl && myTemp.bottomBtnCount < 6) {

  $(".btn_street").addClass("menu_show");
  myTemp.bottomBtnCount++;
  $(".btn_street").on("click", function () {
    AddCount(8);
    location.href = myPageData.Streeturl;
  })
}
//周边
if (myPageData.Nearbyurl && myTemp.bottomBtnCount < 6) {
  $(".btn_nearby").addClass("menu_show");
  myTemp.bottomBtnCount++;
  $(".btn_nearby").on("click", function () {
    AddCount(9);
    location.href = myPageData.Nearbyurl;
  })
}
//抽奖
if (myPageData.Luckdrawurl && myTemp.bottomBtnCount < 6) {
  $(".btn_luckdraw").addClass("menu_show");
  myTemp.bottomBtnCount++;
  if (myPageData.Luckdrawurl.indexOf('http') != 0) {
    let encodeUrls = JSON.parse(myPageData.Luckdrawurl)
    if (encodeUrls.name) {
      $(".btn_luckdraw .txt").html(encodeUrls.name)
    }
  }
  $(".btn_luckdraw").on("click", function () {
    AddCount(10);
    if (myPageData.Luckdrawurl.indexOf('http') == 0) {
      location.href = myPageData.Luckdrawurl;
    } else {
      let encodeUrls = JSON.parse(myPageData.Luckdrawurl)
      if (encodeUrls.exturl) {
        if (myTemp.refereeopenid) {
          encodeUrls.exturl = wj.addUrlParamFromObj(encodeUrls.exturl, {
            refereeopenid: myTemp.refereeopenid
          })
        }
        location.href = encodeUrls.exturl
      } else {
        if (myTemp.refereeopenid) {
          encodeUrls.url = wj.addUrlParamFromObj(encodeUrls.url, {
            refereeopenid: myTemp.refereeopenid
          })
        }
        location.href = encodeUrls.url
      }
    }
  })
}
//评论
if (myPageData.Reviewurl && myTemp.bottomBtnCount < 6) {
  $(".btn_review").addClass("menu_show");
  myTemp.bottomBtnCount++;
  $(".btn_review").on("click", function () {
    AddCount(11);
    location.href = myPageData.Reviewurl;
  })
}
//表单
if ((myPageData.Formurl || myPageData.Formexturl) && myTemp.bottomBtnCount < 6) {
  $(".btn_form").addClass("menu_show");
  myTemp.bottomBtnCount++;
  if (myPageData.Formname) {
    $(".btn_form .txt").html(myPageData.Formname)
  }
  $(".btn_form").on("click", function () {
    AddCount(12);
    if (myPageData.Formexturl) {
      location.href = myPageData.Formexturl;
    } else {
      location.href = myPageData.Formurl;
    }
  })
}
// 更多表单
if (myPageData.Funcscfg && myTemp.bottomBtnCount < 6) {
  myPageData.Funcscfg = JSON.parse(myPageData.Funcscfg);
  if (myPageData.Funcscfg && myPageData.Funcscfg.length > 0) {
    myPageData.Funcscfg.forEach((item, index) => {
      if (myTemp.bottomBtnCount < 6) {
        $(".btn_form_more" + index).addClass("menu_show");
        myTemp.bottomBtnCount++;
        if (item.label) {
          $(".btn_form_more" + index + " .txt").html(item.label);
        }
        $(".btn_form_more" + index).on("click", function () {
          AddCount(12);
          if (item.exturl) {
            location.href = item.exturl;
          } else {
            location.href = item.url;
          }
        })
      }
    })
  }
}
// 小程序按钮
if (myPageData.Funcscfg_wxxcx && myTemp.bottomBtnCount < 5) {
  myPageData.Funcscfg_wxxcx = JSON.parse(myPageData.Funcscfg_wxxcx);
  if (myPageData.Funcscfg_wxxcx && myPageData.Funcscfg_wxxcx.length > 0) {
    myPageData.Funcscfg_wxxcx.forEach((item, index) => {
      if (myTemp.bottomBtnCount < 6) {
        if (item.xcxid && item.xcxname && item.xcxpath) {
          myTemp.bottomBtnCount++;
          $(".btn_xcx_more" + index).addClass("menu_show");
          $(".btn_xcx_more" + index).css("display", "block");
          var mpPath = item.xcxpath;
          if (mpPath.substring(0, 1) != "/") {
            mpPath = "/" + mpPath;
          }
          mpPath = wj.addUrlParamFromObj(mpPath, {
            gzhOpenid: myTemp.openid,
            pageid: myPageData.PageId
          })

          let script = document.createElement("script");
          script.type = "text/wxtag-template";
          script.text = `<img src="${item.xcxicon || 'https://assets.rurushishi.com/yq-rs-h5/xcxicon2.png'}" style=" width: 20px;height: 20px;margin: 10px auto 0 auto;display: block;"/>
          <span style="color: #8ad4fa;font-size: 11px;margin-top: 5px;">${item.xcxname}</span>`;

          let html = `<wx-open-launch-weapp class="btn_xcx_more${index}_mp_launch_wx" username="${item.xcxid}" path="${mpPath}">${script.outerHTML}</wx-open-launch-weapp>`;
          $(".btn_xcx_more" + index + "_mp_launch").html(html);

          $(".btn_xcx_more" + index + "_mp_launch_wx").on('launch', function (e) {
            window.AddCount(100001 + index, {
              funcname: item.xcxname
            })
          });

        }
      }
    })
  }
}

//传播咨询
/**
 * 1、有rscuid聊天对象是rscuid
 * 2、以上步骤没有，则通过获取上级销售找到聊天对象
 * 3、以上步骤没有，则通过获取默认接待找到聊天对象
 * 4、以上步骤没有，则使用默认的PC端咨询回复
 */
// async function setSpreadChat(isAfterActIpGet) {
//   return new Promise(async (resolve, reject) => {
//     if (myTemp.consultingLink && !isAfterActIpGet) {
//       resolve(myTemp.consultingLink)
//     } else {
//       let toId = '';
//       if (myTemp.rscuid && myTemp.rscuid != myTemp.openid) {
//         toId = myTemp.rscuid;
//       } else {
//         let upSaleOpenid = await window.comreq.getUserUpFans();
//         if (upSaleOpenid) {
//           toId = upSaleOpenid;
//         } else {
//           let defaultSaleOpenid = await window.comreq.getReceptionByProject();
//           if (defaultSaleOpenid) {
//             toId = defaultSaleOpenid;
//           }
//         }
//       }
//       if (toId) {
//         // 放开 咨询跳转到新百宝箱聊天页面
//         myTemp.consultingLink = `${location.protocol}//${location.host}/marketies/desk/pages/fans/sale-fans-interaction?receiveropenid=${toId}&projectid=${myPageData.Pid}`;;
//         // if (cfg.isLoc || cfg.isTest) {
//         // } else {
//         //   myTemp.consultingLink = `${location.protocol}//${location.host}/newcode/src/chat_room.html?openid=${myTemp.openid}&passport=${myTemp.passport}&referenceopenid=${myTemp.refereeopenid}&rscuid=${myTemp.rscuid}&receiveropenid=${toId}&nickname=&pageid=${myPageData.PageId}&projectid=${myPageData.Pid}`;
//         // }
//       } else {
//         myTemp.consultingLink = `${location.protocol}//${location.host}/marketies/rc/cus-service.html?mobile=${myPageData.Tel}&referenceopenid=${myTemp.refereeopenid}&pageid=${myPageData.PageId}`;
//       }
//       if (isAfterActIpGet) {
//         myTemp.isAlreadyAfterActIpGetConsultingLink = true;
//         setContentSelf();
//       }
//       resolve(myTemp.consultingLink)
//     }
//   })
// };
if (myPageData.Isconsult && parseInt(myPageData.Isconsult) == 1 && myTemp.bottomBtnCount < 6) {
  $(".btn_consult").addClass("menu_show");
  myTemp.bottomBtnCount++;
  $(".btn_consult").on("click", function () {
    // AddCount(13);
    // setSpreadChat().then(url => {
    //   // 在线售楼中心
    //   if (myTemp.entry == "zxslzx" && myTemp.t9id && myTemp.t9psn) {
    //     url = wj.addUrlParamFromObj(wj.getUrlRemoveParams(url), {
    //       entry: 'zxslzx',
    //       t9id: myTemp.t9id,
    //       t9psn: myTemp.t9psn
    //     })
    //   }
    //   location.href = url;
    // })
    // 20201225采用新逻辑
    let url = myTemp.consultingLink;
    // 在线售楼中心
    if (myTemp.entry == "zxslzx" && myTemp.t9id && myTemp.t9psn) {
      url = wj.addUrlParamFromObj(url, {
        entry: 'zxslzx',
        t9id: myTemp.t9id,
        t9psn: myTemp.t9psn
      })
    }
    location.href = url;
  })
}

//关注
if (myPageData.Showsubcribebtn && parseInt(myPageData.Showsubcribebtn) == 1 && myTemp.bottomBtnCount < 6) {
  $(".btn_subcribe").addClass("menu_show");
  $(".btn_subcribe").on("click", function () {
    AddCount(15);
    location.href = myPageData.Subcribepageurl;
  })
  myTemp.bottomBtnCount++;
}

(function () {
  if (myPageData.Other && myPageData.Other.funcs && myPageData.Other.funcs.length > 0) {
    myPageData.Other.funcs.forEach(item => {
      if (myTemp.bottomBtnCount < 5) {
        let isAdd = false;
        if (item.isvalid == 1) {
          if (item.funcType == "houseconfig") {
            $(".btn_appointment").addClass("menu_show");
            let funcData = item.funcData;
            if (Object.prototype.toString.call(funcData) === "[object String]") {
              funcData = JSON.parse(funcData);
            }
            if (funcData.name) {
              $(".btn_appointment .txt").html(funcData.name)
            }
            $(".btn_appointment").on("click", function () {
              let url = funcData.links;
              let addUrlParams = {
                pageid: myPageData.PageId,
                backurl: encodeURIComponent(location.href)
              }
              if (myTemp.refereeopenid) {
                addUrlParams.refereeopenid = myTemp.refereeopenid;
              }
              if (myTemp.rscuid) {
                addUrlParams.rscuid = myTemp.rscuid;
              }
              let urlDomain = url.split("/");
              url = url.replace(urlDomain[2], location.host);
              url = wj.addUrlParamFromObj(url, addUrlParams);
              location.href = url;
            })
            isAdd = true;
          }
          if (isAdd) {
            myTemp.bottomBtnCount++;
          }
        }
      }
    })
  }
})();

if (myTemp.bottomBtnCount == 1) {
  $(".menu_show").each(function (i, e) {
    // 特殊处理按钮位置
    if (myPageData.PageId == "2168") {
      $(e).css({ "top": "29.5rem", "left": "8rem" });
    } else {
      $(e).css({ "top": "24rem", "left": "8rem" });
    }
  });
} else if (myTemp.bottomBtnCount == 2) {
  $(".menu_show").each(function (i, e) {
    $(e).css({ "top": 18 + i * 5.6 + "rem", "left": "8rem" });
  });
} else if (myTemp.bottomBtnCount == 3) {
  $(".menu_show").each(function (i, e) {
    $(e).css({ "top": 15 + i * 5.6 + "rem", "left": "8rem" });
  });
} else if (myTemp.bottomBtnCount == 4) {
  $(".menu_show").each(function (i, e) {
    if (i % 2 == 0) {//第一列
      $(e).css({ "top": 12 + (i / 2) * 5.6 + "rem", "left": "3rem" });
    }
    else {//第二列
      $(e).css({ "top": 12 + ((i - 1) / 2) * 5.6 + "rem", "left": "12.5rem" });
    }
  });
} else if (myTemp.bottomBtnCount == 5) {
  $(".menu_show").each(function (i, e) {
    if (i < 4) {
      if (i % 2 == 0) {//第一列
        $(e).css({ "top": 12 + (i / 2) * 5.6 + "rem", "left": "3rem" });
      }
      else {//第二列
        $(e).css({ "top": 12 + ((i - 1) / 2) * 5.6 + "rem", "left": "12.5rem" });
      }
    } else if (i == 4) {
      $(e).css({ "top": 12 + (i / 2) * 5.6 + "rem", "left": "8rem" });
    }
  });
} else if (myTemp.bottomBtnCount == 6) {
  $(".menu_show").each(function (i, e) {
    if (i % 2 == 0) {//第一列
      $(e).css({ "top": 12 + (i / 2) * 5.6 + "rem", "left": "3rem" });
    }
    else {//第二列
      $(e).css({ "top": 12 + ((i - 1) / 2) * 5.6 + "rem", "left": "12.5rem" });
    }
  });
}
if (myPageData.WxCode && myPageData.WxQrcode) {
  $(".contact").removeClass("hide");
}
if (myPageData.Tel) {
  $(".customservice").removeClass("hide");
}
if (myPageData.WxCode && myPageData.WxQrcode && myPageData.Tel) {
  $(".dividingline").removeClass("hide");
}
if (myTemp.bottomBtnCount == 0) {
  $(".page .bottom").addClass("hide");
}

if (myPageData.PageId == 4618 || myPageData.PageId == 7199 || myPageData.PageId == 7200
  || myPageData.PageId == 8242) {
  $(".menu_show").css("display", "none");
}
// 根据配置显示按钮位置
if (myPageData.PageId == 8242) {
  $(".btn_luckdraw").css({
    "top": "auto",
    "bottom": "6rem"
  })
}

/**
 * bind data
 */

//绑定内容
if (myPageData.Imgs && myPageData.Imgs.length > 0) {
  $(".images_content").removeClass("hide")
  $(".arrow").addClass("hide");
  myPageData.Imgs.forEach(function (e, i) {
    $(".images_content").append("<div class='images_content_imgwarp'><img src=" + e.filepath + "></div>");
  });

  // 图片内容 slide 不要删除
  // $(".swiper-container").removeClass("hide")
  // myPageData.Imgs.forEach(function (e, i) {
  //   $(".swiper-wrapper").append("<div class='swiper-slide'><img src=" + e.filepath + "></div>");
  // });
  // if (parseInt(myPageData.PageId) >= 22994) {
  //   var tmpSwiperWarpperImgs = $(".swiper-wrapper img");
  //   if (tmpSwiperWarpperImgs && tmpSwiperWarpperImgs.length > 0) {
  //     tmpSwiperWarpperImgs = Array.prototype.slice.call(tmpSwiperWarpperImgs);
  //     tmpSwiperWarpperImgs.forEach(function (e) {
  //       e.style.height = "auto";
  //       e.style.position = "absolute";
  //       e.style.left = "0px";
  //       e.style.clip = `rect(0px,${myTemp.windowWidth}px,${myTemp.windowHeight}px,0px)`;
  //     })
  //   }
  // }
} else if (myPageData.Imagetext && myPageData.Imagetext != "") {
  // 图文内容
  // $(".page").css("overflow", "scroll");
  $(".arrow").addClass("hide");
  $(".image-text-warp").removeClass("hide");
  var imgText = decodeURIComponent(myPageData.Imagetext.replace(/[+]/g, "%20")).replace(/padding:0 5px;/g, "");
  imgText = imgText.replace(/height:[\s]?[0-9.]*px[\s]?!important;/g, "height: auto!important;");
  imgText = imgText.replace(/preview.html\?width=[0-9]*[&]?(amp;)?height=[0-9]*[&]?(amp;)?/g, "preview.html?");
  $(".image-text_content").append(imgText);
  beautifyImageText();
} else if (myPageData.Video) {
  // 视频内容
  var videoFullScreen = document.querySelector("#videoFullScreen");
  videoFullScreen.src = myPageData.Video;
  videoFullScreen.poster = myPageData.Videoposter;
  $(".arrow").addClass("hide");
  $(".full-screen-video").removeClass("hide");
  if (wj.browser.versions.ios) {
    document.addEventListener("WeixinJSBridgeReady", function () {
      var intervalVideo = setInterval(function () {
        if (videoFullScreen.paused) {
          videoFullScreen.play();
        } else {
          clearInterval(intervalVideo)
        }
      }, 1000)
    }, false);
  } else {
    $(".full-screen-video").on("click", function () {
      videoFullScreen.play();
    });
  }
}

function beautifyImageText() {
  var audios = $(".rs-audio");
  audios.each(function (i, e) {
    $(e).css("display", "none");
    var audio_title = $(e).attr("rs-title");
    if (!audio_title || audio_title == undefined) {
      audio_title = null;
    }
    var audio_warp = document.createElement("div");
    audio_warp.className = "audio_warp";
    audio_warp.innerHTML = '<div class="left">' +
      '<div class="btn audio_control' + i + '">' +
      '</div>' +
      '</div>' +
      '<div class="right">' +
      '<strong class="share_audio_title">' + (audio_title || "没有标题"
      )
      + '</strong>' +
      '<span class="share_audio_tips db">来自如是</span>' +
      '<span class="db share_audio_progress_wrp">' +
      '<span class="db share_audio_progress share_audio_progress' + i + '">' +
      '<span class="share_audio_progress_inner share_audio_progress_inner' + i + '"></span>' +
      '<span class="share_audio_progress_buffer"></span>' +
      '<span class="share_audio_progress_loading share_audio_progress_loading' + i + '" style="display:none;">' +
      '<span class="share_audio_progress_loading_inner"></span>' +
      '</span>' +
      '</span>' +
      '<span class="share_audio_progress_handle share_audio_progress_handle' + i + '" style="display:none;left:0%;">' +
      '</span>' +
      '<span class="share_audio_desc db" aria-labelledby="时长">' +
      '<em  class="share_audio_length_current share_audio_length_current' + i + '" aria-hidden="true">00:00</em>' +
      '<em  class="share_audio_length_total share_audio_length_total' + i + '">00:00</em>' +
      '</span>' +
      '</span>' +
      '</div>';

    var audioTemp = {
      TimeLength: 0,
      PlayTime: 0,
      Interval: null,
      ProgressWidth: 0,
      HandleIsFirstTouch: true,
      HandleOriginalStartX: 0,
      HandleOriginalStartY: 0,
    };
    e.preload = "auto";
    e.muted = true;
    e.play();
    setTimeout(function () {
      e.muted = false;
      e.pause();
      e.currentTime = 0;
    }, 100)
    e.onloadedmetadata = function () {
      $(".share_audio_length_total" + i).html(formatAudioTime(e.duration));
      audioTemp.TimeLength = parseInt(e.duration);
    }

    $(audio_warp).find(".btn").on("click", function () {
      if (myTemp.img_text.audioList.length > 0) {
        myTemp.img_text.audioList.forEach(function (audioObj, audioIndex) {
          if (audioObj.audioIndex != i) {
            clearInterval(audioObj.interval);
            $("audio")[audioObj.audioIndex].pause();
            $(".audio_control" + audioObj.audioIndex).removeClass("audio_play");
          }
        })
      }

      audioTemp.ProgressWidth = $(audio_warp).find(".share_audio_progress" + i).width();
      if (e.readyState == 3) {
        $(".share_audio_progress_loading" + i).css({ "display": "block" });
        e.muted = true;
        e.play();
        var temp1 = setInterval(function () {
          if (parseInt(e.currentTime) > 1) {
            e.muted = false;
            e.pause();
            e.currentTime = 0;
            $(audio_warp).find(".btn").tap();
            clearInterval(temp1);
          }
        }, 100)
      }
      else if (e.readyState == 2 || e.readyState == 4) {
        e.muted = false;
        $(".share_audio_progress_loading" + i).css({ "display": "none" });
        if (e.paused) {
          e.play();
          $(this).addClass("audio_play");
          $(".share_audio_progress_handle" + i).css({ "display": "block" });
          var that = this;
          audioTemp.Interval = setInterval(function () {
            if (audioTemp.PlayTime < audioTemp.TimeLength) {
              audioTemp.PlayTime++;
              $(".share_audio_progress_inner" + i).css({
                "width": (audioTemp.PlayTime / audioTemp.TimeLength) * 100 + "%"
              })
              $(".share_audio_progress_handle" + i).css({
                "left": (audioTemp.PlayTime / audioTemp.TimeLength) * 100 + "%"
              })

              $(".share_audio_length_current" + i).html(formatAudioTime(audioTemp.PlayTime));
            } else {
              $(that).removeClass("audio_play");
              audioTemp.PlayTime = 0;
              clearInterval(audioTemp.Interval);
              $(".share_audio_progress_inner" + i).css({
                "width": (audioTemp.PlayTime / audioTemp.TimeLength) * 100 + "%"
              })
              $(".share_audio_progress_handle" + i).css({
                "left": (audioTemp.PlayTime / audioTemp.TimeLength) * 100 + "%"
              })
              $(".share_audio_length_current" + i).html("00:00");
            }
          }, 1000)
          var obj = {
            interval: audioTemp.Interval,
            audioIndex: i
          }
          myTemp.img_text.audioList.push(obj);
        } else {
          clearInterval(audioTemp.Interval);
          e.pause();
          $(this).removeClass("audio_play");
        }
      }
    })

    $(audio_warp).find(".share_audio_progress_handle" + i).on("touchstart", function (event) {
      console.log("touchstart");
      console.log(event);
      if (audioTemp.HandleIsFirstTouch) {
        audioTemp.HandleIsFirstTouch = false;
        audioTemp.HandleOriginalStartX = event.originalEvent.touches[0].clientX;
        audioTemp.HandleOriginalStartY = event.originalEvent.touches[0].clientY;
      }

    })

    $(audio_warp).find(".share_audio_progress_handle" + i).on("touchmove", function (event) {

      console.log("ontouchmove");
      console.log(event);
      var clientX = event.originalEvent.touches[0].clientX;
      var scale = 0;
      if (audioTemp.HandleOriginalStartX <= clientX && clientX < (audioTemp.HandleOriginalStartX + audioTemp.ProgressWidth)) {
        var temp = clientX - audioTemp.HandleOriginalStartX;
        scale = (temp / audioTemp.ProgressWidth) * 100;
        $(this).css({
          "left": scale + "%"
        })
        $(".share_audio_progress_inner" + i).css({
          "width": scale + "%"
        })
        audioTemp.PlayTime = (scale * audioTemp.TimeLength) / 100;
        $(".share_audio_length_current" + i).html(formatAudioTime(audioTemp.PlayTime));
        e.currentTime = audioTemp.PlayTime;
        if (e.paused) {
          $(audio_warp).find(".btn").tap();
        }
      }


    })
    $(audio_warp).find(".share_audio_progress_handle" + i).on("touchend", function (event) {
      console.log("ontouchend");
      console.log(event);
    })


    $(e).after(audio_warp);

  })
}

function formatAudioTime(time) {
  var ss = parseInt(time);
  var s = parseInt(ss % 60);
  if (s < 10) {
    s = "0" + s;
  }
  var m = parseInt(ss / 60);
  if (m < 10) {
    m = "0" + m;
  }
  var h = parseInt(ss / 6000);
  if (h > 1) {
    return h + ":" + m + ":" + s;
  } else {
    return m + ":" + s;
  }
}

//绑定致电电话
// if (wj.qs("ucallphone")) {
//   $(".btn_zd_a").attr("href", "tel:" + wj.qs("ucallphone"));
// }
// else if (myPageData.Propcall) {
//   //在上传在线信息之后会调用getRegistUserMobile();
// } else {
//   $(".btn_zd_a").attr("href", "tel:" + myPageData.Tel);
// }
function getRegistUserMobile() {
  // 20201225不在采用这个逻辑了
  return;
  $.ajax({
    type: "GET",
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/hb/HbH5Action/getUserUpFans",
        "requestParam": {
          "pageid": parseInt(myPageData.PageId),
          "refereeopenid": myTemp.refereeopenid
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {
      myTemp.isGetUpUserMobile = true;
      if (data && data.obj) {
        myTemp.receiveMsgOpenId = data.obj;
        $.ajax({
          type: "GET",
          url: api.wx,
          data: {
            j: JSON.stringify({
              "action": "/global/User/getRegistUserMobile",
              "requestParam": {
                "openid": myTemp.receiveMsgOpenId
              },
              "openid": myTemp.openid,
              "passport": myTemp.passport,
              "url": location.href
            })
          },
          success: function (data) {
            if (data && data.obj) {
              myTemp.upUserMobile = data.obj;
              if (wj.isMobileNumber(myTemp.upUserMobile)) {
                $(".btn_zd_a").attr("href", "tel:" + myTemp.upUserMobile);
              } else {
                $(".btn_zd_a").attr("href", "tel:" + myPageData.Tel);
              }
            }
          }
        });
      } else {
        $(".btn_zd_a").attr("href", "tel:" + myPageData.Tel);
      }
    }
  });
}
//绑定官微客服电话
$(".call_href").attr("href", "tel:" + myPageData.Tel);
//绑定官微二维码
$(".qrcode_img").attr("src", myPageData.WxQrcode);
//绑定官微微信号
$(".qrcode_wxno").text(myPageData.WxCode);
//绑定官微客服图片
$(".customservice_img").attr("src", myPageData.CsPic ? myPageData.CsPic : "http://assets.rurushishi.com/h5/img/customservice.png");

//点击致电
$(".btn_zd").on("click", function () {
  let phone = myTemp.saleCardUser && myTemp.saleCardUser.info && myTemp.saleCardUser.info.ui && myTemp.saleCardUser.info.ui.mobile || myPageData.Tel || '';
  if (phone) {
    location.href = `tel:${phone}`;
  } else {
    alert('未配置默认电话')
  }
  AddCount(1);
})
//点击客服咨询
$(".btn_zx").on("click", function () {
  // AddCount(2);
  myPageData.Chat = `${location.protocol}//${location.host}/marketies/rc/cus-service.html`;
  myPageData.Chat = wj.addUrlParamFromObj(myPageData.Chat, {
    mobile: myPageData.Tel || '',
    referenceopenid: myTemp.refereeopenid || '',
    pageid: myPageData.PageId
  })
  location.href = myPageData.Chat;
})
//点击调研
$(".btn_dy").on("click", function () {
  AddCount(3);
  //http://ddipctest.rushinews.com/web/ui/direction.html?page=rs1&classId=22464177237760&questionnaireId=22464176998656&tacheItemId=22464177249025
  // "appid": "asdf",//如是
  //     "openid": "asdf",//如是
  //     "pageid":1,//如是 页面id
  //     "correlationuserid": "sdf",//ddi userid
  //     "correlationextendid": "asfasdf",//ddi 问卷 tacheItemId
  //     "platformtype": 1,
  if (myTemp.processinstanceid) {
    myPageData.Survey += `&processinstanceid=${myTemp.processinstanceid}`;
  }
  location.href = myPageData.Survey;
});
(function () {
  if (myPageData.Wpageid && myPageData.Mall) {
    var tmpStr = `&ptype=t1&pageid=${myPageData.PageId}&openid=${myTemp.openid}&passport=${myTemp.passport}&refereeopenid=${myTemp.refereeopenid}&projectid=${myPageData.Pid}&apihost=${cfg.apihost}&host=${location.host}`;
    if (myTemp.psn) {
      tmpStr += "&psn=" + myTemp.psn;
    }
    if (myTemp.share_api) {
      tmpStr += "&share_api=" + encodeURIComponent(myTemp.share_api);
    }
    let requestParamData = {
      "url": myPageData.Mall + tmpStr
    }
    var insetPageUrlData = {
      openid: myTemp.openid,
      passport: myTemp.passport,
      "url": location.href,
      "action": "/wicre/WicreAction/insetPageUrl",
      "requestParam": requestParamData
    };
    $.ajax({
      type: "GET",
      url: api.wx,
      async: true,
      data: {
        j: JSON.stringify(insetPageUrlData),
        t: 6
      },
      success: function (data) {
        if (data && data.obj) {
          myPageData.MallNew = data.obj;
        }
      }
    });
  }
})();
//点击商城
$(".btn_sc").on("click", function () {
  AddCount(4);
  // 根据myPageData.wpageid判断是否是微创商城
  if (myPageData.Wpageid) {
    if (myPageData.MallNew) {
      location.href = myPageData.MallNew;
    } else {
      setInterval(() => {
        if (myPageData.MallNew) {
          location.href = myPageData.MallNew;
        }
      }, 100);
    }
  } else {
    location.href = myPageData.Mall;
  }
})
//点击直播
$(".btn_live").on("click", function () {
  AddCount(7);
  location.href = myPageData.LiveUrl;
})

//点击特惠
$(".btn_th").on("click", function () {
  closeCard();
  $(".fav").css({
    height: "17rem"
  });
})
//点击特惠-数字按钮
$(".mytd").each(function (i, e) {
  if (i < 9) {
    $(e).on("click", function () {
      enterNum(i);
    })
  }
});
$(".td11").on("click", function () {
  enterNum(-1);
})

function enterNum(i) {
  var str = $(".input").text();
  if (!wj.isNumber(str)) {
    str = "";
  }
  $(".input").text(str + "" + (i + 1) + "");
}

$(".td12").on("click", function () {
  var str = $(".input").text();
  if (str == "") {
    str = "输入您的电话获得专属服务";
  }
  else if (wj.isNumber(str) && str.length > 1) {
    str = str.substring(0, str.length - 1);
  } else if (str.length == 1) {
    str = "输入您的电话获得专属服务";
  }
  $(".input").text(str);
})
$(".td12").on("taphold", function () {
  $(".input").text("输入您的电话获得专属服务");
})
//点击特惠-提交
$(".btn_submit").on("click", function () {
  var strPhone = $(".input").text();
  if (strPhone == "" || strPhone == "输入您的电话获得专属服务") {
    alert("请先填写手机号或电话号！");
  } else if (!wj.isMobileNumber(strPhone)) {
    alert("请填写正确格式的手机号或电话号！");
  } else {
    $(".fav").css({
      height: "0rem"
    });
    var data = {
      phone: strPhone,
      pageid: myPageData.PageId,
      channelid: wj.qs("ch", true),
      refereeopenid: myTemp.refereeopenid,
      openid: myTemp.openid
    }
    if (myTemp.rscuid) {
      data.rscuid = myTemp.rscuid;
    }
    yqAnalytics.setUserInfo({
      openId: myTemp.openid,
      phoneNumber: strPhone
    })
    biz.handlerYqAnalyticsEvent('entryPhoneNumber', {
      phoneNumber: strPhone
    })
    $.ajax({
      type: "POST",
      url: api.h5 + "act=entry",
      data: data,
      success: function () {
        alert("留电成功！");
      }
    });
  }
});
//点击 导航
$(".btn_dh").on("click", function () {
  AddCount(5);
  // location.href = myPageData.NavUrl;
  let urlParam = wj.getParamFromUrl(myPageData.NavUrl);
  let longitude = urlParam.position.split(',')[0];
  let latitude = urlParam.position.split(',')[1];
  wx.openLocation({
    latitude: parseFloat(latitude), // 纬度，浮点数，范围为90 ~ -90
    longitude: parseFloat(longitude), // 经度，浮点数，范围为180 ~ -180。
    name: urlParam.name || '', // 位置名
    address: '', // 地址详情说明
    scale: 16, // 地图缩放级别,整形值,范围从1~28。默认为最大
    infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
  });
})
//点击 官微
$(".btn_gw").on("click", function () {
  closeCard();
  if (cfg.isLoc) {
    if (cfg.helpShowWx % 2 == 0) {
      $(".wx_number").addClass("hide");
      $(".wx_qrcode").removeClass("hide");
    } else {
      $(".wx_qrcode").addClass("hide");
      $(".wx_number").removeClass("hide");
    }
  } else {
    if (wj.browser.versions.wx) {
      $(".wx_number").addClass("hide");
      $(".wx_qrcode").removeClass("hide");
    } else {
      $(".wx_qrcode").addClass("hide");
      $(".wx_number").removeClass("hide");
    }
  }
  $(".wx").css({
    height: "15rem"
  });
  cfg.helpShowWx++;
})
//点击 留言
$(".btn_record").on("click", function () {
  closeCard();
  $(".record").css({
    height: "14rem"
  });
  $(".msg_content").html(myPageData.Record);
});
//点击 晒照
$(".btn_photo").on("click", function () {
  AddCount(6);
  closeCard();
  $(".photo").css({
    height: "20rem"
  });
  document.getElementsByTagName("body")[0].style.overflow = "hidden";
  document.getElementsByTagName("body")[0].style.maxHeight = "100vh";
  $(".msg_content").html(myPageData.Record);
});
//点击 留言弹出框-留言
myTemp.record_localId = 0;
myTemp.record_timer = null;
myTemp.record_timer_num = 1;
$(".record_btn_img").on("click", function () {
  if (myTemp.isRecordIng == 0) {
    myTemp.isRecordIng = 1
    myTemp.record_timer_num = 1;
    myTemp.record_timer = setInterval(function () {
      if (myTemp.record_timer_num % 2 == 0) {
        $(".record_btn_img").attr("src", "http://assets.rurushishi.com/h5/img/record_btn.png");

      } else {
        $(".record_btn_img").attr("src", "http://assets.rurushishi.com/h5/img/record_btn_ing.png");
      }
      myTemp.record_timer_num++;
    }, 500)
    wx.startRecord();
  } else if (myTemp.isRecordIng == 1) {
    myTemp.isRecordIng = 0;
    $(".record_btn_img").attr("src", "http://assets.rurushishi.com/h5/img/record_btn.png");
    clearInterval(myTemp.record_timer);
    $(".msg").removeClass("hide");
    wx.stopRecord({
      success: function (res) {
        var localId = res.localId;

      }
    });
  }
});

//点击 晒照弹出框 上传
document.getElementById("fileToUpload").addEventListener("change", function (event) {
  if (typeof FileReader == "undefined") {
    alert("您的浏览器不支持图像上传！");
  }
  $(".face-cut_ok").text("确 认");
  UploadImg(this.files[0]);
  event.target.value = '';
});

function UploadImg(file) {
  if (!file) {
    return;
  }
  var reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onloadend = function (e) {
    myTemp.sendImgBaseData = this.result;
    if (myTemp.imgFaceCut == null) {
      myTemp.imgFaceCut = $('.face-cut_container >img');
      myTemp.imgFaceCut.attr("src", myTemp.sendImgBaseData);
      myTemp.imgFaceCut.cropper({
        aspectRatio: 9 / 9,
        crop: function (data) {

        }
      });
    } else {
      myTemp.imgFaceCut.cropper('replace', myTemp.sendImgBaseData);
    }
    $(".face-cut").removeClass("hide");
    closeCard();
    // function cut() {
    //     var $imgData = $img.cropper('getCroppedCanvas')
    //     var dataurl = $imgData.toDataURL('image/png');
    //     console.log(dataurl)
    // }

  }
}

$(".face-cut_ok").on("click", function () {
  if ($(".face-cut_ok").text() == "上传中...") {
    return;
  }
  var tmpImgData = myTemp.imgFaceCut.cropper('getCroppedCanvas')
  myTemp.sendImgBaseData = tmpImgData.toDataURL('image/png');
  $(".face-cut_ok").text("上传中...");
  canvasDataURL(myTemp.sendImgBaseData, {
    maxSize: 600,
    quality: 1
  }, function (myData) {
    myTemp.sendImgBaseData = myData;
    console.log(myTemp.sendImgBaseData)
    $.ajax({
      type: "post",
      url: api.wx,
      data: {
        j: JSON.stringify({
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "action": "/ai/face/FaceAction/upload",
          "requestParam": {
            "obj": {
              "device": "wx",
              "base64img": myTemp.sendImgBaseData.split(',')[1],
              "projectid": myPageData.Pid,
              pageid: parseInt(myPageData.PageId)
            }
          }
        })
      },
      success: function (data) {
        if (data && data.code == 0 && data.obj) {
          if (data.errmsg == "上传成功") {
            $(".msg_content").html(myTemp.photoRewardConfig.uploadoktext || data.errmsg)
          } else {
            $(".msg_content").html(data.errmsg)
          }
          $(".msg").removeClass("hide");
          $(".msg_title").on("click", function () {
            $(".face-cut").addClass("hide");
          })
        } else {
          $(".msg_content").html(data.errmsg || '上传失败！')
          $(".msg").removeClass("hide");
          $(".msg_title").on("click", function () {
            $(".face-cut").addClass("hide");
          })
        }
      }
    });
  })
})


$(".face-cut_cancel").on("click", function () {
  $(".face-cut").addClass("hide");
})
$(".face-cut_rotate").on("click", function () {
  myTemp.imgFaceCut.cropper('rotate', 90);
})

function canvasDataURL(path, obj, callback) {
  var img = new Image();
  img.src = path;
  img.onload = function () {
    var that = this;
    // 默认按比例压缩
    var w = that.width,
      h = that.height,
      scale = w / h;
    if (w <= obj.maxSize) {
      return callback(path)
    }
    if (obj.maxSize) {
      if (w > h) {
        w = obj.maxSize;
        h = w / scale;
      } else {
        h = obj.maxSize;
        w = h * scale;
      }
    } else {
      w = obj.width || w;
      h = obj.height || (w / scale);
    }

    var quality = 0.7;  // 默认图片质量为0.7
    //生成canvas
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    // 创建属性节点
    var anw = document.createAttribute("width");
    anw.nodeValue = w;
    var anh = document.createAttribute("height");
    anh.nodeValue = h;
    canvas.setAttributeNode(anw);
    canvas.setAttributeNode(anh);
    ctx.drawImage(that, 0, 0, w, h);
    if (wj.browser.versions.ios) {
      canvas.width = h;
      canvas.height = w;
      ctx.rotate(90 * Math.PI / 180);
      ctx.drawImage(this, 0, 0, w, -h);
    }
    // 图像质量
    if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
      quality = obj.quality;
    }
    // quality值越小，所绘制出的图像越模糊
    var base64 = canvas.toDataURL('image/jpeg', quality);
    // 回调函数返回base64的值
    callback(base64);
  }
}

//关闭弹出框
$(".msg_title").on("click", function () {
  $(".msg").addClass("hide");
});

//点击 页面图片
$(".swiper-slide").on("click", function () {
  closeCard();
})
$(".image-text").on("click", function () {
  closeCard();
});
$(".full-screen-video").on("click", function () {
  closeCard();
});

function closeCard() {
  $(".fav").css({
    height: "0rem"
  });
  $(".wx").css({
    height: "0rem"
  });
  $(".record").css({
    height: "0rem"
  });
  $(".photo").css({
    height: "0rem"
  });
  document.getElementsByTagName("body")[0].style.overflow = "";
  document.getElementsByTagName("body")[0].style.maxHeight = "";
}


//初始化Swiper
var mySwiper = new Swiper('.swiper-container', {

  direction: 'vertical',
  lazyLoading: true,
  mousewheelControl: true,
  watchSlidesProgress: true,
  onInit: function (swiper) {
    swiper.myactive = 0;

  },
  onProgress: function (swiper) {
    for (var i = 0; i < swiper.slides.length; i++) {
      var slide = swiper.slides[i];
      var progress = slide.progress;
      var translate, boxShadow, scale, boxShadowOpacity, es;

      translate = progress * swiper.height * 0.8;
      scale = 1 - Math.min(Math.abs(progress * 0.2), 1);
      boxShadowOpacity = 0;

      slide.style.boxShadow = '0px 0px 10px rgba(0,0,0,' + boxShadowOpacity + ')';

      if (i == swiper.myactive) {
        es = slide.style;
        es.webkitTransform = es.MsTransform = es.msTransform = es.MozTransform = es.OTransform = es.transform = 'translate3d(0,' + (translate) + 'px,0) scale(' + scale + ')';
        es.zIndex = 0;
      } else {
        es = slide.style;
        es.webkitTransform = es.MsTransform = es.msTransform = es.MozTransform = es.OTransform = es.transform = '';
        es.zIndex = 1;
      }
    }
  },
  onTransitionEnd: function (swiper, speed) {
    for (var i = 0; i < swiper.slides.length; i++) {
    }

    swiper.myactive = swiper.activeIndex;

  },
  onSetTransition: function (swiper, speed) {

    for (var i = 0; i < swiper.slides.length; i++) {

      var es = swiper.slides[i].style;
      es.webkitTransitionDuration = es.MsTransitionDuration = es.msTransitionDuration = es.MozTransitionDuration = es.OTransitionDuration = es.transitionDuration = speed + 'ms';

    }

  },
  onSlideChangeEnd: function (swiper) {
    if (swiper.activeIndex == 0) {
      // 首页
      if (myPageData.PageId == 4618 || myPageData.PageId == 7199 || myPageData.PageId == 7200
        || myPageData.PageId == 8242) {

      } else {
        $(".menu_show").css("display", "block");
      }
    }
    else if (swiper.activeIndex == swiper.slides.length - 1) {
      // 最后一页
      $(".arrow").addClass("hide");
      $(".menu_show").css("display", "block");
    } else {
      $(".arrow").removeClass("hide");

      $(".menu_show").addClass("menu_hidden");
      setTimeout(function () {
        $(".menu_show").css("display", "none");
        $(".menu_show").removeClass("menu_hidden");
      }, 400)
    }

    if (swiper.activeIndex == 1) {

    }
    AddHit(myPageData.Imgs[swiper.activeIndex].id);
    SendImgTime(myPageData.Imgs[swiper.activeIndex].id);
  }
});

//统计点击
// 打开小程序从100001（含）开始，另外增加了一个 funcname 字段（小程序的名称）
window.AddCount = function (type, addP) {
  if (myPageData.PageId) {
    var postData = {
      atype: type,
      pageid: myPageData.PageId,
      openid: myTemp.openid,
      refereeopenid: myTemp.refereeopenid
    };
    if (addP) {
      postData = {
        ...postData,
        ...addP
      }
    }
    if (myTemp.rscuid) {
      postData.rscuid = myTemp.rscuid;
    }
    $.ajax({
      type: "POST",
      url: api.h5 + "act=adv",
      data: postData
    });
  }
}


//统计在线时长
function SendTime(callback) {
  if (myPageData.PageId) {
    var data = {
      openid: myTemp.openid,
      pageid: myPageData.PageId,
      tempid: myTemp.guid,
      channelid: wj.qs("ch", true),
      refereeopenid: myTemp.refereeopenid,
      projectid: myPageData.Pid
    };
    if (myTemp.psn) {
      data.psn = myTemp.psn;
    }
    if (myTemp.rscuid) {
      data.rscuid = myTemp.rscuid;
    }
    $.ajax({
      type: "POST",
      url: api.h5 + "act=ip",
      data: data,
      complete: function () {
        // if (!myTemp.rscuid || myTemp.rscuid == myTemp.openid) {
        // }
        if (!myTemp.isAlreadyAfterActIpGetConsultingLink) {
          // setSpreadChat(true);
        }
        if (myPageData.Propcall && !myTemp.isGetUpUserMobile) {
          getRegistUserMobile();
        }

        if (callback) {
          callback();
        }
      }
    });
  }
}
if ((wj.browser.versions.wx && myTemp.openid) || !wj.browser.versions.wx) {
  setTimeout(function () {
    SendTime();
    setInterval(SendTime, 3000);
  }, 1000)
}
//统计查看每张图片的次数和时长
if (myPageData.Imgs && myPageData.Imgs.length > 0) {
  AddHit(myPageData.Imgs[0].id); //记录第一张图片
  SendImgTime(myPageData.Imgs[0].id); //记录第一张图片
  //自动统计每张图片时长
  setInterval(SendPageno, 3000);
}
function AddHit(imgId) {
  if (myPageData.PageId) {
    var data = {
      id: imgId,
      refereeopenid: myTemp.refereeopenid,
      openid: myTemp.openid,
    };
    if (myTemp.rscuid) {
      data.rscuid = myTemp.rscuid;
    }
    $.ajax({
      type: "POST",
      url: api.h5 + "act=doc",
      data: data
    });
  }
}

function SendImgTime(imgId) {
  tmpImgTimeImgId = imgId;
  if (!tmpImgTimeObj[imgId]) {
    tmpImgTimeObj[imgId] = 1;
    SendPageno(1);
  }
}
function SendPageno(timelength) {
  timelength = timelength || 3;
  if (myPageData.PageId && tmpImgTimeImgId > 0) {
    tmpImgTimeObj[tmpImgTimeImgId] += 3;
    var data = {
      pageid: myPageData.PageId,
      pageno: tmpImgTimeImgId,
      timelength: timelength,
      refereeopenid: myTemp.refereeopenid,
      openid: myTemp.openid,
      tempid: myTemp.guid,
    };
    if (myTemp.psn) {
      data.psn = myTemp.psn;
    }
    if (myTemp.rscuid) {
      data.rscuid = myTemp.rscuid;
    }
    $.ajax({
      type: "POST",
      url: api.h5 + "act=pageno",
      data: data
    });
  }
}

function uploadLocation(latitude, longitude, speed, accuracy) {
  $.ajax({
    type: "GET",
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/hb/HbPageReaderDistributionAction/add",
        "requestParam": {
          "openid": myTemp.openid,
          "latitude": latitude,
          "longitude": longitude,
          "pageid": myPageData.PageId,
          "pid": myPageData.Pid
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {

    }
  });
}


function wxShare() {
  if (myPageData.PageId) {
    var data = {
      openid: myTemp.openid,
      pageid: myPageData.PageId,
      refereeopenid: myTemp.refereeopenid
    };
    if (myTemp.psn) {
      data.psn = myTemp.psn;
    }
    if (myTemp.rscuid) {
      data.rscuid = myTemp.rscuid;
    }
    $.ajax({
      type: "POST",
      url: api.h5 + "act=share",
      data: data,
      complete: function () {
      }
    });

    var shareLibOption = {
      pageid: parseInt(myPageData.PageId),
      openid: myTemp.openid,
      passport: myTemp.passport,
      apiurl: api.wx.replace("?", ""),
      refereeopenid: myTemp.refereeopenid,
    }
    if (myPageData.Showsharepage == 1) {
      ShareLibSDK.showShareWin(shareLibOption)
    }
    biz.handlerYqAnalyticsEvent('share')
  }
}


var isSendClientInfo = 0;
function sendClientInfo() {
  if (myPageData.PageId) {
    var formater = new UAFormat();
    var formaterResult = formater.getResult();
    var mobileModel = formaterResult.device.model;
    var mobileVendor = formaterResult.device.vendor;
    var mobileType = formaterResult.device.type;
    if (mobileModel == "iPhone") {
      mobileModel = MobileDevice.getModels().join(' or ');
      // iPhone X、iPhone XS
      var isIPhoneX = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812;
      // iPhone XS Max
      var isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896;
      // iPhone XR
      var isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896;
      if (isIPhoneX) {
        mobileModel = 'iPhone X';
      }
      if (isIPhoneXSMax) {
        mobileModel = 'iPhone XS Max';
      }
      if (isIPhoneXR) {
        mobileModel = 'iPhone XR';
      }
    } else if (mobileModel == "unknown") {
      var u = navigator.userAgent
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 || u.indexOf('Adr') > -1; //g
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        mobileType = 'mobile'
        var sss = u.split(";");
        for (var k = 0; k < sss.length; k++) {
          if (sss[k].indexOf("Build/") > -1) {
            mobileModel = sss[k].split("Build/")[0]
            mobileVendor = '';
          }
        }
      }
      else if (isIOS) {
        mobileType = 'ios mobile'
      } else {
        mobileType = 'Browser'
      }
    }
    if (mobileVendor.indexOf("ZTE ") > -1) {
      mobileVendor = "ZTE";
    }
    var data = {
      info: wj.clientInfo,
      pageid: myPageData.PageId,
      refereeopenid: myTemp.refereeopenid,
      model: mobileModel,
      vendor: mobileVendor,
      type: mobileType,
      openid: myTemp.openid,
    };
    if (myTemp.psn) {
      data.psn = myTemp.psn;
    }
    if (myTemp.rscuid) {
      data.rscuid = myTemp.rscuid;
    }
    $.ajax({
      type: "POST",
      url: api.h5 + "act=mt",
      data: data,
      complete: function () {
        isSendClientInfo = 1;
        clearInterval(intervalClientInfo);
      }
    });
    if (mobileModel.indexOf("iPhone X") > -1) {
      $(".page .bottom").css("padding-bottom", "0.5rem");
    }
  }
}
var intervalClientInfo = setInterval(function () {
  if (isSendClientInfo == 0) {
    sendClientInfo();
  }
}, 1000);

function initIScroll() {

  // var windowHeight = $(window).innerHeight();
  //
  // $(".image-text").css({
  //     height: windowHeight
  // });
  new IScroll('.image-text-warp', {
    useTransition: true,
    click: true
  });
}

function getCount() {
  $.ajax({
    type: "GET",
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/hb/HbH5Action/pageCounter",
        "requestParam": {
          obj: {
            "id": parseInt(myPageData.PageId)
          }
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {
      if (data && data.obj && data.obj.length > 0) {
        var countShares = 0;
        var countPv = 0;
        data.obj.forEach(function (item) {
          if (item.type == "shares") {
            myTemp.countShares = item.count;
          } else if (item.type == "pv") {
            myTemp.countPv = item.count;
          } else if (item.type == "likes") {
            myTemp.likes = item.count;
          } else if (item.type == "islike") {
            myTemp.islike = item.count;
          }
        })
        // 顶部统计数据
        // if (myPageData.Showpv && myPageData.Showpv == 1) {
        //   $(".count_pv span").text("阅读" + countPv + "次")
        //   $(".count_pv").removeClass("hide")
        // }
        // if (myPageData.Showshares && myPageData.Showshares == 1) {
        //   $(".count_shares span").text("" + countShares + "次")
        //   $(".count_shares").removeClass("hide")
        // }

        // 底部统计数据
        if (myPageData.Showpv && myPageData.Showpv == 1) {
          $(".footer_left_see").removeClass("hide");
          $(".image-text_footer-pv").text(myTemp.countPv);
          if (myPageData.PageId == 59000) {
            $(".image-text_footer-pv").text("10万+");
          }
        }
        if (myPageData.Showshares && myPageData.Showshares == 1) {
          $(".footer_left_share").removeClass("hide");
          $(".image-text_footer-sharecount").text(myTemp.countShares);
        }
        if (myPageData.Wxstyle) {
          $(".footer_left_like").removeClass("hide");
          if (myTemp.islike > 0) {
            $(".image-text_footer-xin").attr("src", "http://assets.rurushishi.com/h5/img/foot_xin_2.png");
          }
          $(".image-text_footer-praise-count").text(myTemp.likes);
        }
      }
    }
  });
}


if (myPageData.PageId == "1501") {
  $(".btn_dy_a .txt").html("登录")
}
if (myPageData.PageId == "1537" || myPageData.PageId == "1893") {

  $(".btn_form").css("display", "none");
}
if (myPageData.PageId == "1893") {
  $(".btn_form").css("top", "32rem");
}

//活动邀约
if (myPageData.Act_invite == 1) {


  $.ajax({
    type: "GET",
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/workflow/WFAction/updateIsReadActivityInfo",
        "requestParam": {
          "pageid": parseInt(myPageData.PageId)
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {

    }
  });

  $.ajax({
    type: "GET",
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/workflow/WFAction/getActUser",
        "requestParam": {
          "pageid": parseInt(myPageData.PageId),
          "projectid": parseInt(myPageData.Pid),
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {
      $(".invite").removeClass("hide");
      if (data && data.obj && data.obj.isjoin == 1) {
        $(".btnJoin").html("已参加")
      } else {
        $(".btnJoin").on("click", function () {
          if ($(".btnJoin").html() != "已参加") {
            joinAct();
          }
        })
      }
    }
  });

}
function joinAct() {

  $.ajax({
    type: "GET",
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/workflow/WFAction/joinAct",
        "requestParam": {
          obj: {
            "projectid": parseInt(myPageData.Pid),
            "pageid": parseInt(myPageData.PageId),
            "activityname": decodeURIComponent(wj.qs("actname"))
          }
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {
      if (data && data.obj && data.obj == 1) {
        $(".btnJoin").html("已参加")
        alert("确认参加成功！")
      }
    }
  });
}


(function () {

  var appUserCard = {
    cookieKeys: {
      cardid: "usercard2_cardid",
      uuid: "usercard2_uuid",
      masteropenid: "usercard2_masteropenid",
      projectid: "usercard2_projectid"
    },
    cookieDuration: 60 * 3,
    logInfo: {
      cardid: '',
      uuid: '',
      masteropenid: '',
      projectid: '',
    }
  }
  initUserCard();
  function initUserCard() {
    appUserCard.logInfo.cardid = wj.cookie.get(appUserCard.cookieKeys.cardid);
    appUserCard.logInfo.uuid = wj.cookie.get(appUserCard.cookieKeys.uuid);
    appUserCard.logInfo.masteropenid = wj.cookie.get(appUserCard.cookieKeys.masteropenid);
    appUserCard.logInfo.projectid = wj.cookie.get(appUserCard.cookieKeys.projectid);
    if (appUserCard.logInfo.cardid && appUserCard.logInfo.uuid && appUserCard.logInfo.masteropenid && appUserCard.logInfo.projectid) {
      userCardLog();
      setInterval(userCardLog, 5000);
    }

  }
  function userCardLog() {
    $.ajax({
      type: "GET",
      url: api.wx,
      data: {
        j: JSON.stringify({
          "action": "/electroniccard/ElectronicCardAction/saveCardLog",
          "requestParam": {
            obj: {
              cardid: appUserCard.logInfo.cardid,//电子名片模板id
              uuid: appUserCard.logInfo.uuid,//前端生成的唯一标识
              masteropenid: appUserCard.logInfo.masteropenid,//当前电子名片所属人的openid
              projectid: appUserCard.logInfo.projectid,
              referenceopenid: myTemp.refereeopenid
            }
          },
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "url": location.href
        })
      },
      success: function (data) {

      }
    });
  }
})();

// 内容自行动
window.setContentSelf = function () {

  let self_action_time = 15;//15秒 3的倍数
  let self_action_count = 0;//当前计时时长
  // 先判断是否开启内容自行动
  $.ajax({
    type: "GET",
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/sales/pageselfconfig/getPageSelfConfig",
        "requestParam": {
          obj: {
            pageid: myPageData.PageId
          }
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {
      if (data) {
        if (wj.isObject(data.obj)) {
          initSelf();
        }
      }
    }
  });

  function initSelf() {
    let zxdObj = wj.cookie.get("t1_20180910_self_" + myPageData.PageId);
    if (zxdObj) {
      // 如果打开过就显示小球,开启计时器等待参数初始化完成
      let tmpInterval = setInterval(function () {
        if (myPageData.PageId && myTemp.openid && myTemp.passport && myTemp.consultingLink) {
          setShareLibSDK(1);
          clearInterval(tmpInterval);
        }
      }, 100)
    } else {
      // 开启计时器
      let tmpInterval = setInterval(function () {
        self_action_count++;
        if (self_action_count == self_action_time && myPageData.PageId && myTemp.openid && myTemp.passport && myTemp.consultingLink) {
          setShareLibSDK(0);
          wj.cookie.set("t1_20180910_self_" + myPageData.PageId, "true", 365 * 24 * 60 * 60);
          clearInterval(tmpInterval);
        }
      }, 1000)
    }
  }

  function setShareLibSDK(type) {
    if (type == 0) {
      // 播放声音
      window.ContentSelfAudio && window.ContentSelfAudio.play();
    }
    if (myPageData.PageId && myTemp.openid && myTemp.passport && myTemp.consultingLink) {
      let option = {
        pageid: myPageData.PageId,
        openid: myTemp.openid,
        refereeopenid: myTemp.refereeopenid,
        passport: myTemp.passport,
        chaturl: myTemp.consultingLink.replace("http://", location.protocol + "//"),
        apiurl: api.wx
      }
      if (type == 1) {
        option.type = 1;
      }
      // 在有rscuid的情况把rscuid当成refereeopid传进来，不传链接上的refereeopenid参数
      if (myTemp.rscuid) {
        option.refereeopenid = myTemp.rscuid
      }
      ShareLibSDK.showPageSelfConfig(option)
    }
  }

};

(function () {
  if (myTemp.xcxuid && myTemp.xcxappid && myTemp.xcxprojectid && myTemp.xcxgzhappid && myTemp.openid && myTemp.passport) {
    $.ajax({
      type: "POST",
      async: true,
      url: "https://wxmp.ruthus.com/api/v1/open/bindRsGzhinfo",
      data: {
        uid: myTemp.xcxuid,
        appid: myTemp.xcxappid,
        projectid: myTemp.xcxprojectid,
        gzhAppid: myTemp.xcxgzhappid,
        gzhOpenid: myTemp.openid,
        gzhPassport: myTemp.passport
      },
      complete: function (data) {
        // wj.cookie.delete("xcxuid");
        // wj.cookie.delete("xcxappid");
        // wj.cookie.delete("xcxprojectid");
        // wj.cookie.delete("xcxgzhappid");
      }
    });
  }
})();

(function () {
  if (myTemp.purephonenumber && myTemp.openid) {
    let postObj = {
      phone: myTemp.purephonenumber,
      pageid: myPageData.PageId,
      psn: myTemp.psn,
      channelid: 0,
      refereeopenid: myTemp.refereeopenid,
      openid: myTemp.openid,
      purpose: 2,//2 光速登录留电
    }
    if (myTemp.rscuid) {
      postObj.rscuid = myTemp.rscuid;
    }
    $.ajax({
      type: "POST",
      url: api.h5 + "act=entry",
      data: postObj,
      success: function () {
      }
    });
    yqAnalytics.setUserInfo({
      openId: myTemp.openid,
      phoneNumber: myTemp.purephonenumber
    })
    biz.handlerYqAnalyticsEvent('mpPhoneNumber', {
      phoneNumber: myTemp.purephonenumber
    })
  }
})();

function checkIsHaveOldMp() {
  /**
   * 悦房云 yuefangy
   * 江西万科 jxwk
   * 安联e家 alej
   * 正宏置业 zhzy
   * 联实 lianshi
   * 原圈云
   */
  var domainList = [
    // "yuefangy",
    // "jxwk",
    // "alej",
    // "zhzy",
    // "lianshi"
    // "yuanquan"
  ];
  var isHave = false;
  domainList.forEach(function (item) {
    if (location.host.indexOf(item + ".") > -1) {
      isHave = true;
    }
  })
  return isHave;
}
(function () {
  // 首页按钮逻辑
  if (myTemp.entry == "zxslzx" && myTemp.t9id && myTemp.t9psn) {
    // 在线售楼中心
    $(".btn_home img").attr("src", "https://assets.rurushishi.com/yq-rs-make/components/btn_home/home2.png?x-oss-process=image/resize,h_100,w_100")
    $(".btn_home").removeClass("hide");
    $(".btn_home").on("click", function () {
      let url = location.protocol + "//" + location.host + "/h5/t9";
      url += "?id=" + myTemp.t9id;
      url += "&psn=" + myTemp.t9psn;
      if (myTemp.refereeopenid) {
        url += "&refereeopenid=" + myTemp.refereeopenid;
      }
      if (myTemp.rscuid) {
        url += "&rscuid=" + myTemp.rscuid;
      }
      wj.getismp(function (ismp) {
        if (ismp && !checkIsHaveOldMp()) {
          wj.mp.rel("/pages/webview/common/common?url=" + encodeURIComponent(url));
        } else {
          location.href = url;
          return false;
        }
      })
    })
  } else if (location.host.indexOf("rywlkj.") > -1) {
    // 润亿网络科技
    wj.getismp(function (ismp) {
      if (ismp) {
        // 我要看房 小程序
        $(".btn_home").removeClass("hide");
        $(".btn_home").on("click", function () {
          wj.mp.switch("/pages/rs/index/index");
        });
      }
    })
  } else if (location.host.indexOf("shxyh.") > -1) {
    // 上海星悦会
    wj.getismp(function (ismp) {
      if (ismp) {
        // 星盟Starunion 小程序
        $(".btn_home").removeClass("hide");
        $(".btn_home").on("click", function () {
          wj.mp.red("/pages/rs/index/index");
        });
      }
    })
  } else if (myTemp.entry == "tyzx") {
    // 在线体验中心
    if (location.host.indexOf("lianshi.") > -1 && myTemp.homeurl) {
      $(".btn_home img").attr("src", "http://rs.static.quanc.com.cn/lsplatform/backIndex.png")
      $(".btn_home").removeClass("hide");
      $(".btn_home").on("click", function () {
        location.href = decodeURIComponent(myTemp.homeurl);
      })
    }
  }
})();


(function () {
  window.alert = function (text) {
    //解析alert内容中的换行符
    text = text.toString().replace(/\\/g, '\\').replace(/\n/g, '<br />').replace(/\r/g, '<br />');
    // 自定义DIV弹窗
    var alertdiv = '<div style="position: fixed;z-index: 1000;left: 0;right: 0;top: 0;bottom: 0;background-color: rgba(0,0,0,0.5);"><div style="position: absolute;overflow: hidden;top: 40%;left: 50%;text-align: center;line-height: 22px;background-color: #fff;border-radius: 12px;width: 280px;padding: 0;margin-left: -140px;z-index: 1000;"><div style="line-height: 30px;font-size: 15px;font-weight: bold;color: #333333;">提示</div><div style="min-height: 60px;line-height: 30px;text-align: center;padding: 0 20px;">' + text + '<br /></div><div style="line-height: 40px;color: #27B3D0;border-top: 1px solid #efefef;font-size: 15px;" onclick="$(this).parent().parent().remove(); ">确定</div></div></div>';
    $(document.body).append(alertdiv);
  };
})();

// (function () {
//   if (wj.qs("j")) {
//     setTimeout(() => {

//       let paramObj = {
//         id: myPageData.PageId,
//         psn: myTemp.psn,
//         refereeopenid: myTemp.refereeopenid || undefined,
//         rscuid: myTemp.rscuid || undefined,
//       }
//       let newObj = {}
//       Object.keys(paramObj).forEach(key => {
//         if (paramObj[key] != undefined) {
//           newObj[key] = paramObj[key]
//         }
//       })
//       paramObj = newObj;

//       window.history.replaceState(null, null, '?' + wj.objToUrlParam(newObj))
//     }, 1000);
//   }
// })();

// 绑定微信openid到企微外部联系人帐号
(function () {
  let urlParam = wj.getParamFromUrl(location.href);
  if (urlParam.corpId && urlParam.extAccount && urlParam.fromAccount && urlParam.accountType && myTemp.openid) {
    let postParams = {
      openid: myTemp.openid,
      accountOrgid: urlParam.corpId,
      accountType: urlParam.accountType,
      appType: urlParam.appType == 1 ? 1 : 0,
      extAccount: urlParam.extAccount,
      fromAccount: urlParam.fromAccount
    }
    if (urlParam.hasOwnProperty('cfgId')) {
      postParams.cfgId = urlParam.cfgId;
    }
    if (urlParam.hasOwnProperty('state')) {
      postParams.state = urlParam.state;
    }
    comreq.userAccountBindExternal(postParams);
  }
})();